<template>
  <div v-title title="资料填写">
    <div class="hred">
      <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
      <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>
    <div class="jindu">
      <div><p :class="{p2:type>0}">1</p><span :class="{span2:type>0}">办学方向</span></div>
      <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>1,p1:type==1}">2</p><span :class="{span2:type>1,span1:type==1}">办学条件</span></div>
      <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>2,p1:type<3}">3</p><span
          :class="{span2:type>2,span1:type<3}">规范办学</span></div>
      <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>3,p1:type<4}">4</p><span
          :class="{span2:type>3,span1:type<4}">场所情况</span></div>
      <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>4,p1:type<5}">5</p><span
          :class="{span2:type>4,span1:type<5}">人员配置</span></div>
        <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>5,p1:type<6}">6</p><span
              :class="{span2:type>5,span1:type<6}">社会效益</span></div>
    </div>

    <div style="margin-top: 20px;margin-bottom: 20px;">
      <img class="img " src="@/images/biaodan/u113.png">
    </div>
  </div>
  <!-- 表单1 -->
  <el-form ref="form1" :model="form1" label-width="80px" v-if="type==1">
    <el-row>
      <el-col :span="24" >
        <el-form-item label-width="140px" class="hang" label="办学宗旨" >
          <el-tooltip  placement="right">
              <template #content>
                  <div style="white-space: pre-wrap;">
                      {{bxzzTip}}
                  </div>
              </template>
              <span><i class="el-icon-question" /></span>
          </el-tooltip>
          <el-input class="inputs" disabled  placeholder="请上传办学宗旨，支持jpg，png，jpeg，pdf格式" v-model="form1.bxzz"/>
          <el-upload accept=".jpg,.png,.jpeg,.pdf"
                  class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="bxzz"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload1"
                     :auto-upload="true"
                     :disabled="this.updateDisable">
            <div class="buttons1">上传</div>
          </el-upload>
                <span class="xing">*</span>
                <el-select class="selectScore" :disabled="this.updateDisable" v-model="form1.bxzzSelfScore" placeholder="请选择分数" >
                    <el-option label="0分" :value="0"></el-option>
                    <el-option label="3分" :value="3"></el-option>
                </el-select><span class="fontStyle">   *</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" >
          <el-form-item label-width="140px" class="hang" label="办学目标" >
              <el-tooltip  placement="right">
                  <template #content>
                      <div style="white-space: pre-wrap;">
                          {{bxmbTip}}
                      </div>
                  </template>
                  <span><i class="el-icon-question" /></span>
              </el-tooltip>
              <el-input class="inputs" disabled  placeholder="请上传办学目标，支持jpg，png，jpeg，pdf格式" v-model="form1.bxmb"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="bxmb"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
              </el-upload>
              <span class="xing">*</span>
              <el-select class="selectScore" :disabled="this.updateDisable" v-model="form1.bxmbSelfScore" placeholder="请选择分数">
                  <el-option label="0分" :value="0"></el-option>
                  <el-option label="2分" :value="2"></el-option>
              </el-select><span class="fontStyle">   *</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="党的建设" >
              <el-tooltip  placement="right">
                  <template #content>
                      <div style="white-space: pre-wrap;">
                          {{ddjsTip}}
                      </div>
                  </template>
                  <span><i class="el-icon-question" /></span>
              </el-tooltip>
              <el-input class="inputs" disabled placeholder="请上传党的建设，支持jpg，png，jpeg，pdf格式" v-model="form1.ddjs"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="ddjs"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
              </el-upload>
              <span class="xing">*</span>
              <el-select class="selectScore" :disabled="this.updateDisable" v-model="form1.ddjsSelfScore" placeholder="请选择分数">
                  <el-option label="0分" :value="0"></el-option>
                  <el-option label="1分" :value="1"></el-option>
                  <el-option label="2分" :value="2"></el-option>
                  <el-option label="3分" :value="3"></el-option>
                  <el-option label="4分" :value="4"></el-option>
                  <el-option label="5分" :value="5"></el-option>
              </el-select><span class="fontStyle">   *</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="机构类型">
          <el-select class="selects" :disabled="this.updateDisable" v-model="form1.jbzxzType" placeholder="请选择机构类型" @change="changeBoundary1">
            <el-option
                v-for="item in jbzxz"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            ></el-option>
          </el-select>
          <span class="xing">*</span>
        </el-form-item>
      </el-col>
      <el-col v-if="this.yyzz1" :span="24">
        <el-form-item label-width="140px" class="hang" label="营业执照" >
          <el-tooltip  placement="right">
              <template #content>
                  <div style="white-space: pre-wrap;">
                      {{yyzzTip}}
                  </div>
              </template>
              <span><i class="el-icon-question" /></span>
          </el-tooltip>
          <el-input class="inputs" disabled  placeholder="请上传营业执照，支持jpg，png，jpeg，pdf格式" v-model="form1.fdzz"/>
          <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="fdzz"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload1"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true"
                     :disabled="this.updateDisable">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span>
            <el-select class="selectScore" :disabled="this.updateDisable" v-model="form1.fdzzSelfScore" placeholder="请选择分数" >
                <el-option label="0分" :value="0"></el-option>
                <el-option label="1分" :value="1"></el-option>
            </el-select><span class="fontStyle">   *</span>
        </el-form-item>
      </el-col>
      <el-col v-if="!this.yyzz1" :span="24">
        <el-form-item label-width="140px" class="hang" label="民办非企业单位登记证书">
          <el-tooltip  placement="right">
              <template #content>
                  <div style="white-space: pre-wrap;">
                      {{yyzzTip}}
                  </div>
              </template>
              <span><i class="el-icon-question" /></span>
          </el-tooltip>
          <el-input class="inputs" disabled placeholder="请上传民办非企业单位登记证书，支持jpg，png，jpeg，pdf格式" v-model="form1.fdzz"/>
          <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="fdzz"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload1"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true"
                     :disabled="this.updateDisable">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span>
            <el-select class="selectScore" :disabled="this.updateDisable" v-model="form1.fdzzSelfScore" placeholder="请选择分数" >
                <el-option label="0分" :value="0"></el-option>
                <el-option label="1分" :value="1"></el-option>
            </el-select><span class="fontStyle">   *</span>
        </el-form-item>
      </el-col>
      <el-col  :span="24">
        <el-form-item label-width="140px" class="hang" label="备案公示" >
          <el-tooltip  placement="right">
              <template #content>
                  <div style="white-space: pre-wrap;">
                      {{bagsTip}}
                  </div>
              </template>
              <span><i class="el-icon-question" /></span>
          </el-tooltip>
          <el-input class="inputs" disabled  placeholder="请上传备案公示，支持jpg，png，jpeg，pdf格式" v-model="form1.bags"/>
          <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="bags"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload1"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true"
                     :disabled="this.updateDisable">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span>
            <el-select class="selectScore" :disabled="this.updateDisable" v-model="form1.bagsSelfScore" placeholder="请选择分数" >
                <el-option label="0分" :value="0"></el-option>
                <el-option label="2分" :value="2"></el-option>
            </el-select><span class="fontStyle">   *</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" >
        <el-form-item label-width="140px" class="hang" label="办学内容" >
          <el-tooltip  placement="right">
              <template #content>
                  <div style="white-space: pre-wrap;">
                      {{bxnrTip}}
                  </div>
              </template>
              <span><i class="el-icon-question" /></span>
          </el-tooltip>
          <el-input class="inputs" disabled  placeholder="请上传办学内容，支持jpg，png，jpeg，pdf格式" v-model="form1.bxnr"/>
          <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="bxnr"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload1"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true"
                     :disabled="this.updateDisable">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span>
            <el-select class="selectScore" :disabled="this.updateDisable" v-model="form1.bxnrSelfScore" placeholder="请选择分数" >
                <el-option label="0分" :value="0"></el-option>
                <el-option label="2分" :value="2"></el-option>
            </el-select><span class="fontStyle">   *</span>
        </el-form-item>
      </el-col>
      <span style="color: red;font-weight: bold;margin-left: 38%" v-if="this.updateDisable">{{this.updateDisableTips}}</span>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="goIndex">返回首页</div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>
  <!--  表单2-->
  <el-form ref="form2" :model="form2" label-width="80px" v-if="type==2">
    <el-row>
      <h3 >决策机制</h3>
        <el-col :span="24">
            <el-form-item label-width="140px" class="hang" label="机构名称" >
                <el-tooltip placement="right" >
                    <template #content>
                        <div style="white-space: pre-wrap;">
                            {{jgmcTip}}
                        </div>
                    </template>
                    <span ><i class="el-icon-question" /></span>
                </el-tooltip>
                <el-input class="inputs" :disabled="this.updateDisable" v-model="form2.orgName" placeholder="请填写机构名称" @input="inputnow" maxlength="50"/>
                <span class="xing">*</span>
                <el-select class="selectScore" style="padding-left:15%" :disabled="this.updateDisable" v-model="form2.orgNameSelfScore" placeholder="请选择分数">
                    <el-option label="0分" :value="0"></el-option>
                    <el-option label="1分" :value="1"></el-option>
                </el-select><span class="fontStyle">   *</span>
            </el-form-item>
        </el-col>

        <el-col :span="24">
            <el-form-item label-width="140px" class="hang" label="机构规章制度">
                <el-tooltip placement="right">
                    <template #content>
                        <div style="white-space: pre-wrap;">
                            {{gzzdTip}}
                        </div>
                    </template>
                    <span><i class="el-icon-question" /></span>
                </el-tooltip>
                <el-input class="inputs" style="width: 53.3%" disabled  placeholder="请上传规章制度，支持jpg，png，jpeg，pdf格式" v-model="form2.gzzd"/>
                <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                           ref="upload"
                           :multiple="false"
                           name="gzzd"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload2"
                           :before-upload="beforeUploadFile1"
                           :auto-upload="true"
                           :disabled="this.updateDisable">
                    <div class="buttons1">上传</div>
                    <!-- slot="trigger" 为触发文件选择框的内容 -->
                </el-upload>
                <span class="xing">*</span>
                <el-select class="selectScore" style="padding-left:12%" :disabled="this.updateDisable" v-model="form2.gzzdSelfScore" placeholder="请选择分数">
                    <el-option label="0分" :value="0"></el-option>
                    <el-option label="1分" :value="1"></el-option>
                    <el-option label="2分" :value="2"></el-option>
                    <el-option label="3分" :value="3"></el-option>
                </el-select><span class="fontStyle" >*</span>
            </el-form-item>
        </el-col>
        <h4>举办者</h4>
        <el-tooltip placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{jbzxzTip}}
                </div>
            </template>
            <span style="margin-top: 20px;margin-left: 10px"><i class="el-icon-question" /></span>
        </el-tooltip>
        <div style="margin-bottom: 40px;margin-left: 30px;width: 120%">


            <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 77%;padding-top: 2%;width: 17.5%" v-model="form2.jbzxzSelfScore" placeholder="请选择分数">
                <el-option label="0分" :value="0"></el-option>
                <el-option label="1分" :value="1"></el-option>
                <el-option label="2分" :value="2"></el-option>
                <el-option label="3分" :value="3"></el-option>
            </el-select>
            <span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>

            <div
                    style="margin-top:20px;width:97%;display: flex;background: #e9f2fd">
                <span style="width: 10%;text-align: center;">序号</span>
                <span style="width: 20%;text-align: center;">举办者性质</span>
                <span style="width: 20%;text-align: center;">法人姓名</span>
                <span style="width: 30%;text-align: center;">身份证号</span>
<!--                <span style="width: 15%;text-align: center;">身份证正面照</span>
                <span style="width: 15%;text-align: center;">身份证反面照</span>
                <span style="width: 15%;text-align: center;">无犯罪证明</span>
                <span style="width: 10%;text-align: center;">营业执照</span>
                <span style="width: 15%;text-align: center;">信用中国截图</span>-->
                <span style="width: 30%;text-align: center;">社会统一代码</span>

                <span style="width: 10%;text-align: center;">操作</span>
            </div>
            <div v-for="(item,index) in form2.jbzList" :key="index">
                <div
                        style="margin-top:20px;width:100%;display: flex;height: 20px;">
                    <span style="width: 10%;text-align: center;">{{ index + 1 }}</span>
                    <span style="width: 20%;text-align: center;" v-if="item.jbzxzType == 1">自然人</span>
                    <span style="width: 20%;text-align: center;" v-else-if="item.jbzxzType == 2">企业单位</span>
                    <span style="width: 20%;text-align: center;">{{ item.frxm }}</span>
                    <span style="width: 30%;text-align: center;">{{ item.sfzh }}</span>
<!--                    <span style="width: 15%;text-align: center;" v-if="item.sfzz">已上传</span>
                    <span style="width: 15%;text-align: center;" v-else-if="!item.sfzz">未上传</span>
                    <span style="width: 15%;text-align: center;" v-if="item.sfzf">已上传</span>
                    <span style="width: 15%;text-align: center;" v-else-if="!item.sfzf">未上传</span>
                    <span style="width: 15%;text-align: center;" v-if="item.wfzzm">已上传</span>
                    <span style="width: 15%;text-align: center;" v-else-if="!item.wfzzm">未上传</span>
                    <span style="width: 10%;text-align: center;" v-if="item.yyzz">已上传</span>
                    <span style="width: 10%;text-align: center;" v-else-if="!item.yyzz">未上传</span>
                    <span style="width: 15%;text-align: center;" v-if="item.xyzgjt">已上传</span>
                    <span style="width: 15%;text-align: center;" v-else-if="!item.xyzgjt">未上传</span>-->
                    <span style="width: 30%;text-align: center;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ item.creditCode }}</span>
                    <span style="width: 10%;text-align: center;">
              <el-button :disabled="this.updateDisable" @click="shanchujbz(index)" type="info">删除</el-button>
          </span>

                </div>
            </div>
        </div>
        <el-col style="width: 70%">
            <el-form-item  label-width="140px" class="hang" label="新增举办者" >
                <el-col style="display: flex">
                    <el-select class="selects" style="width: 52%" :disabled="this.updateDisable" v-model="jbz.jbzxzType" placeholder="请选择" @change="changeBoundary2">
                        <el-option
                                v-for="item in jbzxzArr"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id"
                        ></el-option>
                    </el-select>


                </el-col>
                <el-col style="margin-top: 5px;">
                    <el-form-item >
                        <el-input v-if="this.yyzz2" style="width:83.5%;margin-top:1%" class="inputs" :disabled="this.updateDisable" placeholder="请填写社会统一代码" v-model="jbz.creditCode" @input="inputnow" maxlength="18"/>
                        <el-input class="inputs" style="width:83.5%;margin-top:1%" :disabled="this.updateDisable" placeholder="请填写法人姓名" v-model="jbz.frxm" @input="inputnow" maxlength="20"/>
                        <el-input class="inputs" style="width:83.5%;margin-top:1%" :disabled="this.updateDisable" placeholder="请填写法人身份证号" v-model="jbz.sfzh" @input="inputnow" maxlength="20"/>


                        <el-input v-if="this.yyzz2" style="width:83.5%;margin-top:1%" class="inputs" disabled placeholder="请上传营业执照，支持jpg，png，jpeg，pdf格式" v-model="jbz.yyzz"/>
                        <el-upload v-if="this.yyzz2" accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   ref="upload"
                                   :multiple="false"
                                   name="yyzz"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :before-upload="beforeUploadFile1"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                            <!-- slot="trigger" 为触发文件选择框的内容 -->
                        </el-upload>

                        <el-input v-if="this.yyzz2" style="width:83.5%;margin-top:1%" class="inputs" disabled placeholder="请上传信用中国截图，支持jpg，png，jpeg格式" v-model="jbz.xyzgjt"/>
                        <el-upload v-if="this.yyzz2" accept=".jpg,.png,.jpeg" class="upload-demo"
                                   ref="upload"
                                   :multiple="false"
                                   name="xyzgjt"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :before-upload="beforeUploadFile1"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                            <!-- slot="trigger" 为触发文件选择框的内容 -->
                        </el-upload>

                        <el-input class="inputs" style="width:83.5%;margin-top:1%" disabled placeholder="请上传身份证正面照片，支持jpg，png，jpeg格式" v-model="jbz.sfzz"/>
                        <el-upload accept=".jpg,.png,.jpeg" class="upload-demo"
                                   ref="upload"
                                   :multiple="false"
                                   name="sfzz"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :before-upload="beforeUploadFile1"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                            <!-- slot="trigger" 为触发文件选择框的内容 -->
                        </el-upload>

                        <el-input class="inputs" style="width:83.5%;margin-top:1%" disabled placeholder="请上传身份证反面照片，支持jpg，png，jpeg格式" v-model="jbz.sfzf"/>
                        <el-upload accept=".jpg,.png,.jpeg" class="upload-demo"
                                   ref="upload"
                                   :multiple="false"
                                   name="sfzf"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :before-upload="beforeUploadFile1"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                            <!-- slot="trigger" 为触发文件选择框的内容 -->
                        </el-upload>

                        <el-input class="inputs" style="width:83.5%;margin-top:1%" disabled  placeholder="请上传无犯罪证明，支持jpg，png，jpeg，pdf格式" v-model="jbz.wfzzm"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   ref="upload"
                                   :multiple="false"
                                   name="wfzzm"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :before-upload="beforeUploadFile1"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                            <!-- slot="trigger" 为触发文件选择框的内容 -->
                        </el-upload>

                        <el-input class="inputs" style="width:83.5%;margin-top:1%" disabled  placeholder="请上传合作协议，支持jpg，png，jpeg，pdf格式" v-if="this.form2.jbzList.length>=1" v-model="jbz.hzxy"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   ref="upload"
                                   :multiple="false"
                                   name="hzxy"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :before-upload="beforeUploadFile1"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable"
                                   v-if="this.form2.jbzList.length>=1">
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                            <!-- slot="trigger" 为触发文件选择框的内容 -->
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
                <el-button
                        style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                        @click="zengjiajbz()" :disabled="this.updateDisable" type="danger">保存
                </el-button>
            </el-col>
        </el-col>

      <h3 >场所条件</h3>
      <el-col :span="24">
          <el-form-item label-width="150px" class="hang" label="所属地区" >
              <el-select
                      style="width: 20%;margin-right: 1%"
                      v-model="form2.province"
                      placeholder="省"
                      @change="changeDept($event,0)"
                      :disabled="this.updateDisable"
              >
                  <el-option
                          v-for="item in provinceArry"
                          :key="item.deptId"
                          :label="item.deptName"
                          :value="item.deptId"
                  ></el-option>
              </el-select>
              <el-select
                      style="width: 20%;margin-right:1%"
                      class="center_select"
                      v-model="form2.city"
                      placeholder="市"
                      @change="changeDept($event,1)"
                      :disabled="this.updateDisable"
              >
                  <el-option
                          v-for="item in cityArry"
                          :key="item.deptId"
                          :label="item.deptName"
                          :value="item.deptId"
                  ></el-option>
              </el-select>
              <el-select
                      style="width: 20%;"
                      v-model="form2.district"
                      placeholder="区"
                      @change="changeDept($event,2)"
                      :disabled="this.updateDisable"
              >
                  <el-option
                          v-for="item in districtArry"
                          :key="item.deptId"
                          :label="item.deptName"
                          :value="item.deptId"
                  ></el-option>
              </el-select>
              <span class="xing">*</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="详细地址" >
              <el-input :rows="4" type="textarea" style="width: 61%;" class="inputs" :disabled="this.updateDisable" v-model="form2.xxdz" placeholder="请填写机构详细地址" @input="inputnow"/>
              <span class="xing">*</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="场地性质" >
              <el-select class="selects" style="width: 54%" :disabled="this.updateDisable" v-model="form2.cdxz" placeholder="请选择">
                  <el-option
                          v-for="item in siteTypeArry"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                  ></el-option>
              </el-select>
              <span class="xing">*</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="产权证明">
              <el-input class="inputs" disabled placeholder="请上传产权证明，支持jpg，png，jpeg，pdf格式" v-model="form2.cqzm"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="cqzm"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload2"
                         :before-upload="beforeUploadFile1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
                  <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
              <span class="xing">*</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="教学面积" >
              <el-input class="inputs" :disabled="this.updateDisable" v-model="form2.jxmj" placeholder="请填写教学面积" @input="inputnow" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')" maxlength="15" />
              <span style="margin-left: -28px;z-index: 99; margin-right: 15px;">㎡</span><span class="xing">*</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="办学面积" >
              <el-input class="inputs" :disabled="this.updateDisable" v-model="form2.bxmj" placeholder="请填写办学面积" @input="inputnow" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')" maxlength="15"/>
              <span style="margin-left: -28px;z-index: 99; margin-right: 15px;">㎡</span><span class="xing">*</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="消防证明">
              <el-input class="inputs" disabled placeholder="请上传消防证明，支持jpg，png，jpeg，pdf格式" v-model="form2.xfzm"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="xfzm"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload2"
                         :before-upload="beforeUploadFile1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
                  <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
              <span class="xing">*</span>
          </el-form-item>
      </el-col>
      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="房屋安全鉴定书">
              <el-tooltip placement="right">
                  <template #content>
                      <div style="white-space: pre-wrap;">
                          {{ssdqTip}}
                      </div>
                  </template>
                  <span><i class="el-icon-question" /></span>
              </el-tooltip>
              <el-input class="inputs" style="width: 53.3%" disabled  placeholder="请上传房屋安全鉴定书，支持jpg，png，jpeg，pdf格式" v-model="form2.fwaqjds"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="fwaqjds"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload2"
                         :before-upload="beforeUploadFile1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
                  <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
              <span class="xing">*</span>
              <el-select class="selectScore" style="padding-left: 12%" :disabled="this.updateDisable" v-model="form2.ssdqSelfScore" placeholder="请选择分数">
                  <el-option label="0分" :value="0"></el-option>
                  <el-option label="1分" :value="1"></el-option>
                  <el-option label="2分" :value="2"></el-option>
                  <el-option label="3分" :value="3"></el-option>
              </el-select><span class="fontStyle">   *</span>
          </el-form-item>
      </el-col>

      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="安全制度">
              <el-tooltip placement="right">
                  <template #content>
                      <div style="white-space: pre-wrap;">
                          {{aqzdTip}}
                      </div>
                  </template>
                  <span><i class="el-icon-question" /></span>
              </el-tooltip>
              <el-input class="inputs" style="width: 53.3%" disabled placeholder="请上传安全制度相关文件，支持jpg，png，jpeg，pdf格式" v-model="form2.aqzd"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="aqzd"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload2"
                         :before-upload="beforeUploadFile1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
                  <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
              <span class="xing">*</span>
              <el-select class="selectScore" style="padding-left: 12%" :disabled="this.updateDisable" v-model="form2.aqzdSelfScore" placeholder="请选择分数">
                  <el-option label="0分" :value="0"></el-option>
                  <el-option label="1分" :value="1"></el-option>
              </el-select><span class="fontStyle">   *</span>
          </el-form-item>
      </el-col>

      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="员工安全相关证明">
              <el-tooltip placement="right">
                  <template #content>
                      <div style="white-space: pre-wrap;">
                          {{ygaqxgzmTip}}
                      </div>
                  </template>
                  <span><i class="el-icon-question" /></span>
              </el-tooltip>
              <el-input class="inputs" style="width: 53.3%" disabled placeholder="请上传员工安全相关证明，支持jpg，png，jpeg，pdf格式" v-model="form2.ygaqxgzm"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="ygaqxgzm"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload2"
                         :before-upload="beforeUploadFile1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
                  <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
              <span class="xing">*</span>
              <el-select class="selectScore" style="padding-left: 12%" :disabled="this.updateDisable" v-model="form2.ygaqxgzmSelfScore" placeholder="请选择分数">
                  <el-option label="0分" :value="0"></el-option>
                  <el-option label="1分" :value="1"></el-option>
                  <el-option label="2分" :value="2"></el-option>
              </el-select><span class="fontStyle">   *</span>
          </el-form-item>
      </el-col>

      <el-col :span="24">
          <el-form-item label-width="140px" class="hang" label="意外处置预案">
              <el-tooltip placement="right">
                  <template #content>
                      <div style="white-space: pre-wrap;">
                          {{ywczyaTip}}
                      </div>
                  </template>
                  <span><i class="el-icon-question" /></span>
              </el-tooltip>
              <el-input class="inputs" style="width: 53.3%" disabled placeholder="请上传意外处置预案，支持jpg，png，jpeg，pdf格式" v-model="form2.ywczya"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="ywczya"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload2"
                         :before-upload="beforeUploadFile1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
                  <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
              <span class="xing">*</span>
              <el-select class="selectScore" style="padding-left: 12%" :disabled="this.updateDisable" v-model="form2.ywczyaSelfScore" placeholder="请选择分数">
                  <el-option label="0分" :value="0"></el-option>
                  <el-option label="1分" :value="1"></el-option>
              </el-select><span class="fontStyle">   *</span>
          </el-form-item>
      </el-col>
      <h3 >师资力量</h3>
        <el-tooltip  placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{szllTip}}
                </div>
            </template>
            <span style="margin-top: 20px;margin-left: 10px"><i class="el-icon-question" /></span>
        </el-tooltip>
        <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 67.5%;padding-top: 2%;width: 17.5%" v-model="form2.szllSelfScore" placeholder="请选择分数">
            <el-option label="0分" :value="0"></el-option>
            <el-option label="1分" :value="1"></el-option>
            <el-option label="2分" :value="2"></el-option>
            <el-option label="3分" :value="3"></el-option>
            <el-option label="4分" :value="4"></el-option>
            <el-option label="5分" :value="5"></el-option>
            <el-option label="6分" :value="6"></el-option>
        </el-select>
        <span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
        <div style="margin-bottom: 40px;margin-left: 30px;width: 100%">
            <div
                    style="margin-top:20px;width:97%;display: flex;background: #e9f2fd">
                <span style="width: 7%;text-align: center;">序号</span>
                <span style="width: 20%;text-align: center;">姓名</span>
                <span style="width: 30%;text-align: center;">身份证号</span>
                <span style="width: 25%;text-align: center;">身份证正面照片</span>
                <span style="width: 25%;text-align: center;">身份证反面照片</span>
                <span style="width: 15%;text-align: center;">劳动合同</span>
                <span style="width: 20%;text-align: center;">从业资格证书</span>
                <span style="width: 30%;text-align: center;">操作</span>
            </div>
            <div v-for="(item,index) in form2.szllList" :key="index">
                <div
                        style="margin-top:20px;width:100%;display: flex;height: 20px;">
                    <span style="width: 7%;text-align: center;">{{ index + 1 }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.jsxm }}</span>
                    <span style="width: 30%;text-align: center;">{{ item.jssfzh }}</span>
                    <span style="width: 25%;text-align: center;" v-if="item.jssfzz">已上传</span>
                    <span style="width: 25%;text-align: center;" v-else-if="!item.jssfzz">未上传</span>
                    <span style="width: 25%;text-align: center;" v-if="item.jssfzf">已上传</span>
                    <span style="width: 25%;text-align: center;" v-else-if="!item.jssfzf">未上传</span>
                    <span style="width: 15%;text-align: center;" v-if="item.jsldht">已上传</span>
                    <span style="width: 15%;text-align: center;" v-else-if="!item.jsldht">未上传</span>
                    <span style="width: 20%;text-align: center;" v-if="item.jscyzgzs">已上传</span>
                    <span style="width: 20%;text-align: center;" v-else-if="!item.jscyzgzs">未上传</span>
                    <span style="width: 30%;text-align: center;">
              <el-button :disabled="this.updateDisable" @click="shanchujiaoshi(index)" type="info">删除</el-button>
          </span>

                </div>
            </div>
        </div>
        <el-col style="width: 70%">
            <el-form-item  label-width="140px" class="hang" label="新增教师" >
                <el-col style="display: flex">
                    <el-input class="inputs" style="width:40%" @input="inputnow" :disabled="this.updateDisable" v-model="szll.jsxm"
                              placeholder="请填写教师姓名" maxlength="20"/>
                    <el-input class="inputs" style="width:42%" @input="inputnow" :disabled="this.updateDisable" v-model="szll.jssfzh"
                              placeholder="请填写教师身份证号" maxlength="20"/>
                </el-col>
                <el-col style="margin-top: 5px;">
                    <el-form-item >
                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="szll.jssfzz" placeholder="请上传身份证正面照片，支持jpg，png，jpeg格式"/>
                        <el-upload accept=".jpg,.png,.jpeg" class="upload-demo"
                                   :data="{name:'jssfzz',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                        </el-upload>

                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="szll.jssfzf" placeholder="请上传身份证反面照片，支持jpg，png，jpeg格式"/>
                        <el-upload accept=".jpg,.png,.jpeg" class="upload-demo"
                                   :data="{name:'jssfzf',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                        </el-upload>

                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="szll.jsldht" placeholder="请上传劳动合同，支持jpg，png，jpeg，pdf格式"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   :data="{name:'jsldht',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <!--                    <el-button  type="primary" style="margin-top: 12%">上传</el-button>-->
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                        </el-upload>

                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="szll.jscyzgzs" placeholder="请上传从业资格证书，支持jpg，png，jpeg，pdf格式"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   :data="{name:'jscyzgzs',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload2"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
                            <!--                    <el-button  type="primary" style="margin-top: 12%">上传</el-button>-->
                            <div class="buttons1" style="margin-top: 28%">上传</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
                <el-button
                        style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                        @click="zengjiajiaoshi()" :disabled="this.updateDisable" type="danger">保存
                </el-button>
            </el-col>
        </el-col>
        <span style="color: red;font-weight: bold;margin-left: 38%" v-if="this.updateDisable">{{this.updateDisableTips}}</span>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>
  <!--  表单3-->
  <el-form ref="form3" :model="form3" label-width="80px" v-if="type==3">
    <el-row>
      <el-col :span="24">
        <el-form-item label-width="130px" class="hang" label="收费退费" prop="sftf">
          <el-tooltip placement="right" >
              <template #content>
                  <div style="white-space: pre-wrap;">
                      {{sftfTip}}
                  </div>
              </template>
              <span><i class="el-icon-question" /></span>
          </el-tooltip>
          <el-input class="inputs" placeholder="请上传收费退费证明，支持jpg，png，jpeg，pdf格式" disabled v-model="form3.sftf"/>
          <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                     name="sftf"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload3"
                     :auto-upload="true"
                     :disabled="this.updateDisable">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span>
          <el-select class="selectScore" :disabled="this.updateDisable" v-model="form3.sftfSelfScore" placeholder="请选择分数">
              <el-option label="0分" :value="0"></el-option>
              <el-option label="5分" :value="5"></el-option>
          </el-select><span class="fontStyle">   *</span>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label-width="130px" class="hang" label="资金监管" prop="zjjg">
          <el-tooltip placement="right" >
              <template #content>
                  <div style="white-space: pre-wrap;">
                      {{zjjgTip}}
                  </div>
              </template>
              <span><i class="el-icon-question" /></span>
          </el-tooltip>
          <el-input class="inputs" placeholder="请上传资金监管证明，支持jpg，png，jpeg，pdf格式" disabled  v-model="form3.zjjg"/>
          <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                     ref="upload"
                     name="zjjg"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload3"
                     :auto-upload="true"
                     :disabled="this.updateDisable">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span>
          <el-select class="selectScore" :disabled="this.updateDisable" v-model="form3.zjjgSelfScore" placeholder="请选择分数">
              <el-option label="0分" :value="0"></el-option>
              <el-option label="1分" :value="1"></el-option>
              <el-option label="2分" :value="2"></el-option>
              <el-option label="3分" :value="3"></el-option>
              <el-option label="4分" :value="4"></el-option>
              <el-option label="5分" :value="5"></el-option>
          </el-select><span class="fontStyle">   *</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="130px" class="hang" label="法规执行" prop="fgzx">
            <el-tooltip placement="right" >
                <template #content>
                    <div style="white-space: pre-wrap;">
                        {{fgzxTip}}
                    </div>
                </template>
                <span><i class="el-icon-question" /></span>
            </el-tooltip>
            <el-input class="inputs" placeholder="请上传法规执行证明，支持jpg，png，jpeg，pdf格式" disabled v-model="form3.fgzx"/>
          <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                     name="fgzx"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload3"
                     :auto-upload="true"
                     :disabled="this.updateDisable">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span>
          <el-select class="selectScore" :disabled="this.updateDisable" v-model="form3.fgzxSelfScore" placeholder="请选择分数">
              <el-option label="0分" :value="0"></el-option>
              <el-option label="1分" :value="1"></el-option>
              <el-option label="2分" :value="2"></el-option>
              <el-option label="3分" :value="3"></el-option>
              <el-option label="4分" :value="4"></el-option>
              <el-option label="5分" :value="5"></el-option>
          </el-select><span class="fontStyle">   *</span>
        </el-form-item>
      </el-col>
      <span style="color: red;font-weight: bold;margin-left: 38%" v-if="this.updateDisable">{{this.updateDisableTips}}</span>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>
  <!--  表单4-->
  <el-form ref="form4" :model="form4" label-width="80px" v-if="type==4">
    <el-row>
      <h3>机构办学场所面积</h3>
      <el-tooltip placement="right" >
          <template #content>
              <div style="white-space: pre-wrap;">
                  {{bxcsmjTip}}
              </div>
          </template>
          <span style="margin-left: 20px;margin-top: 20px;"><i class="el-icon-question" /></span>
      </el-tooltip>
      <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 54.8%;padding-top: 2%;"   v-model="form4.bxcsmjSelfScore" placeholder="请选择分数">
          <el-option label="0分" :value="0"></el-option>
          <el-option label="2分" :value="2"></el-option>
          <el-option label="4分" :value="4"></el-option>
          <el-option label="6分" :value="6"></el-option>
      </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
      <el-col :span="24">
          <el-form-item label-width="140px"  label="机构办学场所面积">
              <el-input class="inputs" disabled style="width:70%" placeholder="请上传机构办学场所面积佐证，支持jpg，png，jpeg，pdf格式" v-model="form4.bxcsmj"/>
              <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                         ref="upload"
                         :multiple="false"
                         name="bxcsmj"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload4"
                         :before-upload="beforeUploadFile1"
                         :auto-upload="true"
                         :disabled="this.updateDisable">
                  <div class="buttons1">上传</div>
                  <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
              <span class="xing">*</span>

          </el-form-item>
      </el-col>
      <h3>医疗急救用品</h3>
      <el-tooltip placement="right" >
          <template #content>
              <div style="white-space: pre-wrap;">
                  {{yljjypTip}}
              </div>
          </template>
          <span style="margin-left: 20px;margin-top: 20px;"><i class="el-icon-question" /></span>
      </el-tooltip>
      <el-select class="selectScore" :disabled="this.updateDisable"  style="padding-left: 58.5%;padding-top: 2%;" v-model="form4.yljjypSelfScore" placeholder="请选择分数">
          <el-option label="0分" :value="0"></el-option>
          <el-option label="2分" :value="2"></el-option>
      </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
      <div style="margin-bottom: 40px;margin-left: 76px;width: 100%">
          <div
                  style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
              <span style="width: 20%;text-align: center;">序号</span>
              <span style="width: 20%;text-align: center;">名称</span>
              <span style="width: 20%;text-align: center;">图片</span>
              <span style="width: 20%;text-align: center;">操作</span>
          </div>
          <div v-for="(item,index) in form4.yljjypList" :key="index">
              <div
                      style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
                  <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
                  <span style="width: 20%;text-align: center;">{{ item.name }}</span>
                  <span style="width: 20%;text-align: center;" v-if="item.img">已上传</span>
                  <span style="width: 20%;text-align: center;" v-else-if="!item.img">未上传</span>
                  <span style="width: 20%;text-align: center;">
              <el-button :disabled="this.updateDisable" @click="delyljjyp(index)" type="info">删除</el-button>
          </span>

              </div>
          </div>
      </div>
      <el-col style="width: 70%">
          <el-form-item  label-width="140px" class="hang" label="新增医疗急救用品" >
              <el-col style="display: flex">
                  <el-input class="inputs" style="width:84%" @input="inputnow" :disabled="this.updateDisable" v-model="yljjyp.name"
                            placeholder="请输入医疗急救用品名称" maxlength="30"/>
              </el-col>
              <el-col style="margin-top: 5px;">
                  <el-form-item >
                      <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="yljjyp.img" placeholder="请上传医疗急救用品照片，支持jpg，png，jpeg，pdf格式"/>

                      <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                 :data="{name:'yljjyp',index:index}"
                                 ref="upload"
                                 :multiple="false"
                                 :show-file-list="false"
                                 action="void"
                                 :http-request="customUpload4"
                                 :auto-upload="true"
                                 :disabled="this.updateDisable">
                          <!--                    <el-button  type="primary" style="margin-top: 12%">上传</el-button>-->
                          <div class="buttons1" style="margin-top: 23%">上传</div>
                      </el-upload>
                  </el-form-item>
              </el-col>
          </el-form-item>
          <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
              <el-button
                      style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                      @click="addyljjyp()" :disabled="this.updateDisable" type="danger">保存
              </el-button>
          </el-col>
      </el-col>



      <span style="color: red;font-weight: bold;margin-left: 38%" v-if="this.updateDisable">{{this.updateDisableTips}}</span>
      <div style="margin-top: 20px;margin-bottom: 70px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>
  <!--  表单5-->
  <el-form ref="form5" :model="form5" label-width="80px" v-if="type==5">
    <el-row style="width: 100%">
        <h3>省级退役/高级职称教练员</h3>
        <el-tooltip  placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{sjjlTip}}
                </div>
            </template>
            <span  style="margin-left: 20px;margin-top: 20px;" ><i class="el-icon-question" /></span>
        </el-tooltip>
        <el-select class="selectScore" :disabled="this.updateDisable" style="margin-left: 44%;padding-top: 2%;;width: 18%" v-model="form5.sjjlSelfScore" placeholder="请选择分数">
            <el-option label="0分" :value="0"></el-option>
            <el-option label="2分" :value="2"></el-option>
        </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
      <div style="margin-bottom: 40px;margin-left: 76px;width: 100%">
        <div
            style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
          <span style="width: 20%;text-align: center;">序号</span>
          <span style="width: 20%;text-align: center;">姓名</span>
          <span style="width: 20%;text-align: center;">身份证号</span>
          <span style="width: 20%;text-align: center;">身份证正面</span>
          <span style="width: 20%;text-align: center;">身份证反面</span>
          <span style="width: 20%;text-align: center;">操作</span>
        </div>
        <div v-for="(item,index) in form5.sjjlList" :key="index">
          <div
              style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
            <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
            <span style="width: 20%;text-align: center;">{{ item.name }}</span>
            <span style="width: 20%;text-align: center;">{{ item.idCardNo }}</span>
            <span style="width: 20%;text-align: center;" v-if="item.idCardZ">已上传</span>
            <span style="width: 20%;text-align: center;" v-else-if="!item.idCardZ">未上传</span>
            <span style="width: 20%;text-align: center;" v-if="item.idCardF">已上传</span>
            <span style="width: 20%;text-align: center;" v-else-if="!item.idCardF">未上传</span>
            <span style="width: 20%;text-align: center;">
                <el-button :disabled="this.updateDisable" @click="delsjjl(index)" type="info">删除</el-button>
            </span>

          </div>
        </div>
      </div>
      <el-col style="width: 100%;margin-left: -3%;">
        <el-form-item  label-width="140px" class="hang" label="新增教练员" >
          <el-col style="display: flex">
            <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="sjjl.name"
                      placeholder="教练姓名" maxlength="30"/>
            <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="sjjl.idCardNo"
                      placeholder="教练身份证号码" maxlength="20"/>
          </el-col>
          <el-col style="margin-top: 5px;">
            <el-form-item >
                <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="sjjl.idCardZ" placeholder="请上传身份证正面照，支持jpg，png，jpeg格式"/>
                <el-upload accept=".jpg,.png,.jpeg" class="upload-demo"
                           :data="{name:'sjjlIdCardNoZ',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload5"
                           :auto-upload="true"
                           :disabled="this.updateDisable">
<!--                    <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                    <div class="buttons1" style="margin-top: 23%">上传</div>
                </el-upload>

                <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="sjjl.idCardF" placeholder="请上传身份证反面照，支持jpg，png，jpeg格式"/>
                <el-upload accept=".jpg,.png,.jpeg" class="upload-demo"
                           :data="{name:'sjjlIdCardNoF',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload5"
                           :auto-upload="true"
                           :disabled="this.updateDisable">
<!--                    <el-button  type="primary" style="margin-top: 12%">上传</el-button>-->
                    <div class="buttons1" style="margin-top: 23%">上传</div>
                </el-upload>
            </el-form-item>
          </el-col>

        </el-form-item>
      </el-col>
      <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
          <el-button
                  style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                  @click="addsjjl" :disabled="this.updateDisable" type="danger">保存
          </el-button>
      </el-col>
        <h3>3年经验以上全职教练</h3>
        <el-tooltip  placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{qzjlTip}}
                </div>
            </template>
            <span style="margin-left: 20px;margin-top: 20px;" ><i class="el-icon-question" /></span>
        </el-tooltip>
        <el-select class="selectScore" style="margin-left: 48%;padding-top: 2%;width: 18%"  :disabled="this.updateDisable" v-model="form5.qzjlSelfScore" placeholder="请选择分数">
            <el-option label="0分" :value="0"></el-option>
            <el-option label="1分" :value="1"></el-option>
            <el-option label="2分" :value="2"></el-option>
            <el-option label="3分" :value="3"></el-option>
            <el-option label="4分" :value="4"></el-option>
        </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">   *</span>
      <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">
        <div
            style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
          <span style="width: 20%;text-align: center;">序号</span>
          <span style="width: 20%;text-align: center;">姓名</span>
          <span style="width: 20%;text-align: center;">身份证号</span>
          <span style="width: 20%;text-align: center;">身份证正面</span>
          <span style="width: 20%;text-align: center;">身份证反面</span>
          <span style="width: 20%;text-align: center;">操作</span>
        </div>
        <div v-for="(item,index) in form5.qzjlList" :key="index">
          <div
              style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
              <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
              <span style="width: 20%;text-align: center;">{{ item.name }}</span>
              <span style="width: 20%;text-align: center;">{{ item.idCardNo }}</span>
              <span style="width: 20%;text-align: center;" v-if="item.idCardZ">已上传</span>
              <span style="width: 20%;text-align: center;" v-else-if="!item.idCardZ">未上传</span>
              <span style="width: 20%;text-align: center;" v-if="item.idCardF">已上传</span>
              <span style="width: 20%;text-align: center;" v-else-if="!item.idCardF">未上传</span>
            <span style="width: 20%;text-align: center;">
                <el-button :disabled="this.updateDisable" @click="delqzjl(index)" type="info">删除</el-button>
            </span>
          </div>
        </div>
      </div>
      <el-col style="width: 100%;margin-left: -3%;">
          <el-form-item  label-width="140px" class="hang" label="新增教练员" >
              <el-col style="display: flex">
                  <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="qzjl.name"
                            placeholder="教练姓名" maxlength="30"/>
                  <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="qzjl.idCardNo"
                            placeholder="教练身份证号码" maxlength="20"/>
              </el-col>
              <el-col style="margin-top: 5px;">
                  <el-form-item >
                      <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="qzjl.idCardZ" placeholder="请上传身份证正面照，支持jpg，png，jpeg格式"/>
                      <el-upload accept=".jpg,.png,.jpeg" class="upload-demo"
                                 :data="{name:'qzjlIdCardNoZ',index:index}"
                                 ref="upload"
                                 :multiple="false"
                                 :show-file-list="false"
                                 action="void"
                                 :http-request="customUpload5"
                                 :auto-upload="true"
                                 :disabled="this.updateDisable">
<!--                          <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                          <div class="buttons1" style="margin-top: 23%">上传</div>

                      </el-upload>

                      <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="qzjl.idCardF" placeholder="请上传身份证反面照，支持jpg，png，jpeg格式"/>
                      <el-upload accept=".jpg,.png,.jpeg" class="upload-demo"
                                 :data="{name:'qzjlIdCardNoF',index:index}"
                                 ref="upload"
                                 :multiple="false"
                                 :show-file-list="false"
                                 action="void"
                                 :http-request="customUpload5"
                                 :auto-upload="true"
                                 :disabled="this.updateDisable">
<!--                          <el-button  type="primary" style="margin-top: 12%">上传</el-button>-->
                          <div class="buttons1" style="margin-top: 23%">上传</div>
                      </el-upload>
                  </el-form-item>
              </el-col>

            </el-form-item>
        </el-col>
        <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
            <el-button
                    style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                    @click="addqzjl" :disabled="this.updateDisable" type="danger">保存
            </el-button>
        </el-col>

        <h3>课程研发</h3>
        <el-tooltip placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{kcyfTip}}
                </div>
            </template>
            <span style="margin-left: 20px;margin-top: 20px;" ><i class="el-icon-question" /></span>
        </el-tooltip>
        <el-select class="selectScore" style="margin-left: 59%;padding-top: 2%;width: 18%" :disabled="this.updateDisable" v-model="form5.kcyfSelfScore" placeholder="请选择分数">
            <el-option label="0分" :value="0"></el-option>
            <el-option label="2分" :value="2"></el-option>
        </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
        <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">

            <div
                    style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                <span style="width: 20%;text-align: center;">序号</span>
                <span style="width: 20%;text-align: center;">姓名</span>
                <span style="width: 20%;text-align: center;">职务</span>
                <span style="width: 20%;text-align: center;">研发成果</span>
                <span style="width: 20%;text-align: center;">操作</span>
            </div>
            <div v-for="(item,index) in form5.kcyfList" :key="index">
                <div
                        style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
                    <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.name }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.zw }}</span>
                    <span style="width: 20%;text-align: center;" v-if="item.zs">已上传</span>
                    <span style="width: 20%;text-align: center;" v-else-if="!item.zs">未上传</span>
                    <span style="width: 20%;text-align: center;">
                     <el-button @click="delkcyf(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                </div>
            </div>
        </div>
        <el-col style="width: 100%;margin-left: -3%;">
            <el-form-item  label-width="140px" class="hang" label="新增教研团队" >
                <el-col style="display: flex">
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="kcyf.name"
                              placeholder="教师姓名" maxlength="30"/>
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="kcyf.zw"
                              placeholder="教师职务" maxlength="30"/>
                </el-col>
                <el-col style="margin-top: 5px;">
                    <el-form-item >
                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="kcyf.zs" placeholder="请上传研发成果，支持jpg，png，jpeg，pdf格式"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   :data="{name:'yfcgzs',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload5"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
<!--                            <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                            <div class="buttons1" style="margin-top: 23%">上传</div>
                        </el-upload>
                    </el-form-item>
                </el-col>

            </el-form-item>
        </el-col>
        <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
            <el-button
                    style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                    @click="addkcyf" :disabled="this.updateDisable" type="danger">保存
            </el-button>
        </el-col>

        <h3>急救人员</h3>
        <el-tooltip placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{jjryTip}}
                </div>
            </template>
            <span style="margin-left: 20px;margin-top: 20px;" ><i class="el-icon-question" /></span>
        </el-tooltip>
        <el-select class="selectScore" style="margin-left: 59%;padding-top: 2%;width: 18%" :disabled="this.updateDisable"  v-model="form5.jjrySelfScore" placeholder="请选择分数">
            <el-option label="0分" :value="0"></el-option>
            <el-option label="1分" :value="1"></el-option>
        </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
        <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">
            <div
                    style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                <span style="width: 20%;text-align: center;">序号</span>
                <span style="width: 20%;text-align: center;">姓名</span>
                <span style="width: 20%;text-align: center;">身份证号</span>
                <span style="width: 20%;text-align: center;">证书</span>
                <span style="width: 20%;text-align: center;">操作</span>
            </div>
            <div v-for="(item,index) in form5.jjryList" :key="index">
                <div
                        style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
                    <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.name }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.idCardNo }}</span>
                    <span style="width: 20%;text-align: center;" v-if="item.zs">已上传</span>
                    <span style="width: 20%;text-align: center;" v-else-if="!item.zs">未上传</span>
                    <span style="width: 20%;text-align: center;">
                     <el-button @click="deljjry(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                </div>
            </div>
        </div>
        <el-col style="width: 100%;margin-left: -3%;">
            <el-form-item  label-width="140px" class="hang" label="新增急救人员" >
                <el-col style="display: flex">
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="jjry.name"
                              placeholder="姓名" maxlength="30"/>
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="jjry.idCardNo"
                              placeholder="身份证号" maxlength="20"/>
                </el-col>
                <el-col style="margin-top: 5px;">
                    <el-form-item >
                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="jjry.zs" placeholder="请上传证书，支持jpg，png，jpeg，pdf格式"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   :data="{name:'jjryzs',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload5"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
<!--                            <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                            <div class="buttons1" style="margin-top: 23%">上传</div>
                        </el-upload>
                    </el-form-item>
                </el-col>

            </el-form-item>
        </el-col>
        <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
            <el-button
                    style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                    @click="addjjry" :disabled="this.updateDisable" type="danger">保存
            </el-button>
        </el-col>
        <h3>安保人员</h3>
        <el-tooltip placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{abryTip}}
                </div>
            </template>
            <span style="margin-left: 20px;margin-top: 20px;"><i class="el-icon-question" /></span>
        </el-tooltip>
        <el-select class="selectScore" style="margin-left: 59%;padding-top: 2%;width: 18%" :disabled="this.updateDisable" v-model="form5.abrySelfScore" placeholder="请选择分数">
            <el-option label="0分" :value="0"></el-option>
            <el-option label="1分" :value="1"></el-option>
        </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
        <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">
            <div
                    style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                <span style="width: 20%;text-align: center;">序号</span>
                <span style="width: 20%;text-align: center;">姓名</span>
                <span style="width: 20%;text-align: center;">身份证号</span>
                <span style="width: 20%;text-align: center;">证书</span>
                <span style="width: 20%;text-align: center;">操作</span>
            </div>
            <div v-for="(item,index) in form5.abryList" :key="index">
                <div
                        style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
                    <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.name }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.idCardNo }}</span>
                    <span style="width: 20%;text-align: center;" v-if="item.zs">已上传</span>
                    <span style="width: 20%;text-align: center;" v-else-if="!item.zs">未上传</span>
                    <span style="width: 20%;text-align: center;">
                     <el-button @click="delabry(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                </div>
            </div>
        </div>
        <el-col style="width: 100%;margin-left: -3%;">
            <el-form-item  label-width="140px" class="hang" label="新增安保人员" >
                <el-col style="display: flex">
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="abry.name"
                              placeholder="姓名" maxlength="30"/>
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="abry.idCardNo"
                              placeholder="身份证号" maxlength="20"/>
                </el-col>
                <el-col style="margin-top: 5px;">
                    <el-form-item >
                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="abry.zs" placeholder="请上传证书，支持jpg，png，jpeg，pdf格式"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   :data="{name:'abryzs',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload5"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
<!--                            <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                            <div class="buttons1" style="margin-top: 23%">上传</div>
                        </el-upload>
                    </el-form-item>
                </el-col>

            </el-form-item>
        </el-col>
        <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
            <el-button
                    style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                    @click="addabry" :disabled="this.updateDisable" type="danger">保存
            </el-button>
        </el-col>

        <h3>业务培训人员</h3>
        <el-tooltip placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{ywpxryTip}}
                </div>
            </template>
            <span style="margin-left: 20px;margin-top: 20px;" ><i class="el-icon-question" /></span>
        </el-tooltip>
        <el-select class="selectScore" style="margin-left: 55%;padding-top: 2%;width: 18%" :disabled="this.updateDisable" v-model="form5.ywpxrySelfScore" placeholder="请选择分数">
            <el-option label="0分" :value="0"></el-option>
            <el-option label="1分" :value="1"></el-option>
            <el-option label="2分" :value="2"></el-option>
            <el-option label="3分" :value="3"></el-option>
            <el-option label="4分" :value="4"></el-option>
            <el-option label="5分" :value="5"></el-option>
            <el-option label="6分" :value="6"></el-option>
        </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
        <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">
            <div
                    style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                <span style="width: 20%;text-align: center;">序号</span>
                <span style="width: 20%;text-align: center;">姓名</span>
                <span style="width: 20%;text-align: center;">身份证号</span>
                <span style="width: 20%;text-align: center;">证书</span>
                <span style="width: 20%;text-align: center;">操作</span>
            </div>
            <div v-for="(item,index) in form5.ywpxryList" :key="index">
                <div
                        style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
                    <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.name }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.idCardNo }}</span>
                    <span style="width: 20%;text-align: center;" v-if="item.zs">已上传</span>
                    <span style="width: 20%;text-align: center;" v-else-if="!item.zs">未上传</span>
                    <span style="width: 20%;text-align: center;">
                     <el-button @click="delywpxry(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                </div>
            </div>
        </div>
        <el-col style="width: 100%;margin-left: -3%;">
            <el-form-item  label-width="140px" class="hang" label="新增业务培训人员" >
                <el-col style="display: flex">
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="ywpxry.name"
                              placeholder="姓名" maxlength="30"/>
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="ywpxry.idCardNo"
                              placeholder="身份证号" maxlength="20"/>
                </el-col>
                <el-col style="margin-top: 5px;">
                    <el-form-item >
                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="ywpxry.zs" placeholder="请上传证书，支持jpg，png，jpeg，pdf格式"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   :data="{name:'ywpxryzs',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload5"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
<!--                            <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                            <div class="buttons1" style="margin-top: 23%">上传</div>
                        </el-upload>
                    </el-form-item>
                </el-col>

            </el-form-item>
        </el-col>
        <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
            <el-button
                    style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                    @click="addywpxry" :disabled="this.updateDisable" type="danger">保存
            </el-button>
        </el-col>

        <h3>教练人员</h3>
        <el-tooltip placement="right" >
            <template #content>
                <div style="white-space: pre-wrap;">
                    {{jlryTip}}
                </div>
            </template>
            <span style="margin-left: 20px;margin-top: 20px;"><i class="el-icon-question" /></span>
        </el-tooltip>
        <el-select class="selectScore" style="margin-left: 59%;padding-top: 2%;width: 18%" :disabled="this.updateDisable" v-model="form5.jlrySelfScore" placeholder="请选择分数">
            <el-option label="0分" :value="0"></el-option>
            <el-option label="2分" :value="2"></el-option>
            <el-option label="4分" :value="4"></el-option>
            <el-option label="6分" :value="6"></el-option>
        </el-select><span style="margin-left: 10px;margin-top: 27px;color: red;font-size: 18px;">*</span>
        <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">
            <div
                    style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                <span style="width: 20%;text-align: center;">序号</span>
                <span style="width: 20%;text-align: center;">姓名</span>
                <span style="width: 20%;text-align: center;">身份证号</span>
                <span style="width: 20%;text-align: center;">证书</span>
                <span style="width: 20%;text-align: center;">操作</span>
            </div>
            <div v-for="(item,index) in form5.jlryList" :key="index">
                <div
                        style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
                    <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.name }}</span>
                    <span style="width: 20%;text-align: center;">{{ item.idCardNo }}</span>
                    <span style="width: 20%;text-align: center;" v-if="item.zs">已上传</span>
                    <span style="width: 20%;text-align: center;" v-else-if="!item.zs">未上传</span>
                    <span style="width: 20%;text-align: center;">
                     <el-button @click="deljlry(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                </div>
            </div>
        </div>
        <el-col style="width: 100%;margin-left: -3%;">
            <el-form-item  label-width="140px" class="hang" label="新增教练人员" >
                <el-col style="display: flex">
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="jlry.name"
                              placeholder="姓名" maxlength="30"/>
                    <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="jlry.idCardNo"
                              placeholder="身份证号" maxlength="20"/>
                </el-col>
                <el-col style="margin-top: 5px;">
                    <el-form-item >
                        <el-input class="inputs" style="width:83.5%;margin-top:1%" @input="inputnow" disabled v-model="jlry.zs" placeholder="请上传证书，支持jpg，png，jpeg，pdf格式"/>
                        <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                   :data="{name:'jlryzs',index:index}"
                                   ref="upload"
                                   :multiple="false"
                                   :show-file-list="false"
                                   action="void"
                                   :http-request="customUpload5"
                                   :auto-upload="true"
                                   :disabled="this.updateDisable">
<!--                            <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                            <div class="buttons1" style="margin-top: 23%">上传</div>
                        </el-upload>
                    </el-form-item>
                </el-col>

            </el-form-item>
        </el-col>
        <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
            <el-button
                    style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                    @click="addjlry" :disabled="this.updateDisable" type="danger">保存
            </el-button>
        </el-col>

      <span style="color: red;font-weight: bold;margin-left: 38%" v-if="this.updateDisable">{{this.updateDisableTips}}</span>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>
  <!--  表单6-->
  <el-form ref="form6" :model="form6" label-width="80px" v-if="type==6">
        <el-row>
            <h3>荣誉奖励</h3>
            <el-tooltip placement="right" >
                <template #content>
                    <div style="white-space: pre-wrap;">
                        {{ryjlTip}}
                    </div>
                </template>
                <span style="margin-left: 10px;margin-top: 20px"><i class="el-icon-question" /></span>
            </el-tooltip>
            <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 54.8%;padding-top: 2%;"   v-model="form6.ryjlSelfScore" placeholder="请选择分数">
                <el-option label="0分" :value="0"></el-option>
                <el-option label="2分" :value="2"></el-option>
            </el-select><span style="margin-left: 86%;color: red;font-size: 18px;margin-top: -3.5%">*</span>
            <el-col :span="24">
                <el-form-item label-width="140px" class="hang" label="荣誉奖励">
                    <el-input class="inputs" style="width: 79.5%" disabled  placeholder="请上传荣誉奖励，支持jpg，png，jpeg，pdf格式" v-model="form6.ryjl"/>
                    <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                               ref="upload"
                               :multiple="false"
                               name="ryjl"
                               :show-file-list="false"
                               action="void"
                               :http-request="customUpload6"
                               :before-upload="beforeUploadFile1"
                               :auto-upload="true"
                               :disabled="this.updateDisable">
                        <div class="buttons1">上传</div>
                        <!-- slot="trigger" 为触发文件选择框的内容 -->
                    </el-upload>
                </el-form-item>
            </el-col>
            <h3>群众口碑</h3>
            <el-tooltip placement="right" >
                <template #content>
                    <div style="white-space: pre-wrap;">
                        {{qzkbTip}}
                    </div>
                </template>
                <span style="margin-left: 10px;margin-top: 20px"><i class="el-icon-question" /></span>
            </el-tooltip>
            <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 54.8%;padding-top: 2%;" v-model="form6.qzkbSelfScore" placeholder="请选择分数">
                <el-option label="0分" :value="0"></el-option>
                <el-option label="1分" :value="1"></el-option>
                <el-option label="2分" :value="2"></el-option>
            </el-select><span style="margin-left: 86%;color: red;font-size: 18px;margin-top: -3.5%">*</span>
            <el-col :span="24">
                <el-form-item label-width="140px" class="hang" label="经营年限" prop="jynx">
                    <el-input class="inputs" placeholder="请填写经营年限（只能输入数字）" :disabled="this.updateDisable" v-model="form6.jynx" @input="inputnow" oninput="value=value.replace(/[^0-9.]/g,'')" maxlength="3"/>
                    <span style="margin-left: -28px;z-index: 99; margin-right: 15px;">年</span><span class="xing">*</span>
                </el-form-item>
            </el-col>

            <h3>赛事组织</h3>
            <el-tooltip placement="right" >
                <template #content>
                    <div style="white-space: pre-wrap;">
                        {{sszzTip}}
                    </div>
                </template>
                <span style="margin-left: 10px;margin-top: 20px"><i class="el-icon-question" /></span>
            </el-tooltip>
            <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 54.8%;padding-top: 2%;"   v-model="form6.sszzSelfScore" placeholder="请选择分数">
                <el-option label="0分" :value="0"></el-option>
                <el-option label="1分" :value="1"></el-option>
                <el-option label="2分" :value="2"></el-option>
            </el-select><span style="margin-left: 86%;color: red;font-size: 18px;margin-top: -3.5%">*</span>
            <el-col :span="24">
                <el-form-item label-width="140px" class="hang" label="赛事组织">
                    <el-input class="inputs" style="width: 79.5%" disabled placeholder="请上传赛事组织照片，支持jpg，png，jpeg，pdf格式" v-model="form6.sszz"/>
                    <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                               ref="upload"
                               :multiple="false"
                               name="sszz"
                               :show-file-list="false"
                               action="void"
                               :http-request="customUpload6"
                               :before-upload="beforeUploadFile1"
                               :auto-upload="true"
                               :disabled="this.updateDisable"
                      >
                        <div class="buttons1" >上传</div>
                        <!-- slot="trigger" 为触发文件选择框的内容 -->
                    </el-upload>

                </el-form-item>
            </el-col>

            <h3>参赛人员</h3>
            <el-tooltip  placement="right" >
                <template #content>
                    <div style="white-space: pre-wrap;">
                        {{csryTip}}
                    </div>
                </template>
                <span style="margin-left: 10px;margin-top: 20px"><i class="el-icon-question" /></span>
            </el-tooltip>
            <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 54.8%; padding-top: 2%;"  v-model="form6.csrySelfScore" placeholder="请选择分数">
                <el-option label="0分" :value="0"></el-option>
                <el-option label="1分" :value="1"></el-option>
                <el-option label="2分" :value="2"></el-option>
                <el-option label="3分" :value="3"></el-option>
                <el-option label="4分" :value="4"></el-option>
                <el-option label="5分" :value="5"></el-option>
                <el-option label="6分" :value="6"></el-option>
                <el-option label="7分" :value="7"></el-option>
                <el-option label="8分" :value="8"></el-option>
            </el-select><span style="margin-left: 86%;color: red;font-size: 18px;margin-top: -3.5%">*</span>
            <div style="margin-bottom: 40px;margin-top: 30px;margin-left:76px; width: 100%">
                <div
                        style="margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                    <span style="width: 20%;text-align: center;">序号</span>
                    <span style="width: 20%;text-align: center;">姓名</span>
                    <span style="width: 20%;text-align: center;">身份证号</span>
                    <span style="width: 20%;text-align: center;">资料</span>
                    <span style="width: 20%;text-align: center;">操作</span>
                </div>
                <div v-for="(item,index) in form6.csryList" :key="index">
                    <div
                            style="margin-top:20px;width:80%;display: flex;height: 20px;">
                        <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
                        <span style="width: 20%;text-align: center;">{{ item.name }}</span>
                        <span style="width: 20%;text-align: center;">{{ item.idCardNo }}</span>
                        <span style="width: 20%;text-align: center;" v-if="item.csryTp">已上传</span>
                        <span style="width: 20%;text-align: center;" v-else-if="!item.csryTp">未上传</span>
                        <span style="width: 20%;text-align: center;">
                     <el-button @click="delcsry(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                    </div>
                </div>
            </div>
            <el-col style="width: 100%;margin-left: -3%;">
                <el-form-item  label-width="140px" class="hang" label="新增参赛人员" >
                    <el-col style="display: flex">
                        <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable"  v-model="csry.name"
                                  placeholder="姓名" maxlength="30"/>
                        <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="csry.idCardNo"
                                  placeholder="身份证号" maxlength="20" />
                    </el-col>
                    <el-col style="margin-top: 5px;">
                        <el-form-item >
                            <el-input class="inputs" style="width:83.5%;margin-left: 10px;" @input="inputnow" disabled v-model="csry.csryTp" placeholder="请上传参赛人员资料，支持jpg，png，jpeg，pdf格式"/>
                            <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                       :data="{name:'csryTp',index:index}"
                                       ref="upload"
                                       :multiple="false"
                                       :show-file-list="false"
                                       action="void"
                                       :http-request="customUpload6"
                                       :auto-upload="true"
                                       :disabled="this.updateDisable">
<!--                                <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                                <div class="buttons1">上传</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                </el-form-item>
            </el-col>
            <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
                <el-button
                        style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                        @click="addcsry" :disabled="this.updateDisable" type="danger">保存
                </el-button>
            </el-col>

            <h3>运动员输送</h3>
            <el-tooltip placement="right" >
                <template #content>
                    <div style="white-space: pre-wrap;">
                        {{ydryTip}}
                    </div>
                </template>
                <span style="margin-left: 10px;margin-top: 20px"><i class="el-icon-question" /></span>
            </el-tooltip>
            <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 52.8%; padding-top: 2%;"  v-model="form6.ydrySelfScore" placeholder="请选择分数">
                <el-option label="0分" :value="0"></el-option>
                <el-option label="1分" :value="1"></el-option>
                <el-option label="2分" :value="2"></el-option>
            </el-select><span style="margin-left: 86%;color: red;font-size: 18px;margin-top: -3.5%">*</span>
            <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">
                <div
                        style="margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                    <span style="width: 30%;text-align: center;">序号</span>
                    <span style="width: 30%;text-align: center;">姓名</span>
                    <span style="width: 30%;text-align: center;">身份证号</span>
                    <span style="width: 20%;text-align: center;">操作</span>
                </div>
                <div v-for="(item,index) in form6.ydryList" :key="index">
                    <div
                            style="margin-top:20px;width:80%;display: flex;height: 20px;">
                        <span style="width: 30%;text-align: center;">{{ index + 1 }}</span>
                        <span style="width: 30%;text-align: center;">{{ item.name }}</span>
                        <span style="width: 30%;text-align: center;">{{ item.idCardNo }}</span>
                        <span style="width: 20%;text-align: center;">
                     <el-button @click="delydyss(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                    </div>
                </div>
            </div>
            <el-col style="width: 100%;margin-left: -3%;">
                <el-form-item  label-width="140px" class="hang" label="新增运动员" >
                    <el-col style="display: flex">
                        <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="ydry.name"
                                  placeholder="姓名" maxlength="30"/>
                        <el-input class="inputs" style="width:41%" @input="inputnow" :disabled="this.updateDisable" v-model="ydry.idCardNo"
                                  placeholder="身份证号" maxlength="20"/>
                    </el-col>
                </el-form-item>
            </el-col>
            <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
                <el-button
                        style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                        @click="addydyss" :disabled="this.updateDisable" type="danger">保存
                </el-button>
            </el-col>


            <h3>宣传报道</h3>
            <el-tooltip placement="right" >
                <template #content>
                    <div style="white-space: pre-wrap;">
                        {{xcbdTip}}
                    </div>
                </template>
                <span style="margin-left: 10px;margin-top: 20px"><i class="el-icon-question" /></span>
            </el-tooltip>
            <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 54.8%; padding-top: 2%;"  v-model="form6.xcbdSelfScore" placeholder="请选择分数">
                <el-option label="0分" :value="0"></el-option>
                <el-option label="2分" :value="2"></el-option>
            </el-select><span style="margin-left: 86%;color: red;font-size: 18px;margin-top: -3.5%">*</span>
            <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">
                <div
                        style="margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                    <span style="width: 30%;text-align: center;">序号</span>
                    <span style="width: 30%;text-align: center;">宣传报道日期</span>
                    <span style="width: 30%;text-align: center;">资料</span>
                    <span style="width: 20%;text-align: center;">操作</span>
                </div>
                <div v-for="(item,index) in form6.xcbdList" :key="index">
                    <div
                            style="margin-top:20px;width:80%;display: flex;height: 20px;">
                        <span style="width: 30%;text-align: center;">{{ index + 1 }}</span>
                        <span style="width: 30%;text-align: center;">{{ item.xcbdTime }}</span>
                        <span style="width: 30%;text-align: center;" v-if="item.xcbdTp">已上传</span>
                        <span style="width: 30%;text-align: center;" v-else-if="!item.xcbdTp">未上传</span>
                        <span style="width: 20%;text-align: center;">
                     <el-button @click="delxcbd(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                    </div>
                </div>
            </div>
            <el-col style="width: 100%;margin-left: -3%;">
                <el-form-item  label-width="140px" class="hang" label="新增宣传报道" >
                    <el-col style="display: flex">
<!--                        <el-input class="inputs" style="width:41%" @input="inputnow" v-model="xcbd.xcbdTime"
                                  placeholder="宣传报道日期"/>-->
                        <el-date-picker
                                type="date"
                                v-model="xcbd.xcbdTime"
                                placeholder="请选择宣传报道日期"
                                value-format="YYYY-MM-DD"
                                :disabledDate="pickerOptions"
                                style="width: 41.5%"
                                :disabled="this.updateDisable"
                        />
                    </el-col>
                    <el-col style="margin-top: 5px;">
                        <el-form-item >
                            <el-input class="inputs" style="width:83.5%;margin-left: 0px;" @input="inputnow" disabled v-model="xcbd.xcbdTp" placeholder="请上传宣传报道资料，支持jpg，png，jpeg，pdf格式"/>
                            <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                       :data="{name:'xcbdTp',index:index}"
                                       ref="upload"
                                       :multiple="false"
                                       :show-file-list="false"
                                       action="void"
                                       :http-request="customUpload6"
                                       :auto-upload="true"
                                       :disabled="this.updateDisable">
<!--                                <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                                <div class="buttons1">上传</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                </el-form-item>
            </el-col>
            <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
                <el-button
                        style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                        @click="addxcbd" :disabled="this.updateDisable" type="danger">保存
                </el-button>
            </el-col>


            <h3>公益活动</h3>
            <el-tooltip placement="right" >
                <template #content>
                    <div style="white-space: pre-wrap;">
                        {{gyhdTip}}
                    </div>
                </template>
                <span style="margin-left: 10px;margin-top: 20px"><i class="el-icon-question" /></span>
            </el-tooltip>
            <el-select class="selectScore" :disabled="this.updateDisable" style="padding-left: 54.8%; padding-top: 2%;"  v-model="form6.gyhdSelfScore" placeholder="请选择分数">
                <el-option label="0分" :value="0"></el-option>
                <el-option label="2分" :value="2"></el-option>
            </el-select><span style="margin-left: 86%;color: red;font-size: 18px;margin-top: -3.5%">*</span>
            <div style="margin-bottom: 40px;margin-top: 30px; margin-left: 76px;width: 100%">
                <div
                        style="margin-top:20px;width:80%;display: flex;background: #e9f2fd">
                    <span style="width: 30%;text-align: center;">序号</span>
                    <span style="width: 30%;text-align: center;">公益活动日期</span>
                    <span style="width: 30%;text-align: center;">公益活动资料</span>
                    <span style="width: 20%;text-align: center;">操作</span>
                </div>
                <div v-for="(item,index) in form6.gyhdList" :key="index">
                    <div
                            style="margin-top:20px;width:80%;display: flex;height: 20px;">
                        <span style="width: 30%;text-align: center;">{{ index + 1 }}</span>
                        <span style="width: 30%;text-align: center;">{{ item.gyhdTime }}</span>
                        <span style="width: 30%;text-align: center;" v-if="item.gyhdTp">已上传</span>
                        <span style="width: 30%;text-align: center;" v-else-if="!item.gyhdTp">未上传</span>
                        <span style="width: 20%;text-align: center;">
                     <el-button @click="delgyhd(index)" :disabled="this.updateDisable" type="info">删除</el-button></span>
                    </div>
                </div>
            </div>
            <el-col style="width: 100%;margin-left: -3%;">
                <el-form-item  label-width="140px" class="hang" label="新增公益活动" >
                    <el-col style="display: flex">
                        <el-date-picker
                                type="date"
                                v-model="gyhd.gyhdTime"
                                placeholder="请选择公益活动举办日期"
                                value-format="YYYY-MM-DD"
                                :disabledDate="pickerOptions"
                                style="width: 41.5%"
                                :disabled="this.updateDisable"
                        />
                    </el-col>
                    <el-col style="margin-top: 5px;">
                        <el-form-item >
                            <el-input class="inputs" style="width:83.5%;margin-left: 0px;" @input="inputnow" disabled v-model="gyhd.gyhdTp" placeholder="请上传公益活动资料，支持jpg，png，jpeg，pdf格式"/>
                            <el-upload accept=".jpg,.png,.jpeg,.pdf" class="upload-demo"
                                       :data="{name:'gyhdTp',index:index}"
                                       ref="upload"
                                       :multiple="false"
                                       :show-file-list="false"
                                       action="void"
                                       :http-request="customUpload6"
                                       :auto-upload="true"
                                       :disabled="this.updateDisable">
<!--                                <el-button style="margin-top: 9%" type="primary">上传</el-button>-->
                                <div class="buttons1">上传</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                </el-form-item>
            </el-col>
            <el-col style="margin-left: 170px;margin-bottom: 50px;z-index:99;">
                <el-button
                        style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #409eff;color: #000000;font-size: 20px;font-weight: bold"
                        @click="addgyhd" :disabled="this.updateDisable" type="danger">保存
                </el-button>
            </el-col>
            <span style="color: red;font-weight: bold;margin-left: 38%" v-if="this.updateDisable">{{this.updateDisableTips}}</span>
            <div style="margin-top: 20px;margin-bottom: 20px;">
                <img class="img " src="@/images/biaodan/u113.png">
            </div>
            <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
            <div class="buttons2" size="mini" @click="jichutijiao">提交</div>
        </el-row>
    </el-form>


  <!-- Unnamed (矩形) -->
  <div id="u58" class="ax_default label">
    <div id="u58_div" class=""></div>
    <div id="u58_text" class="text ">
      <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
      <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
      <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
    </div>
  </div>
</template>

<script>
import {
  saveBxfx,//办学方向
  saveBxtj, //办学条件
  saveGfbx,//规范办学
  saveCsqk,//场所情况
  saveRypz,//人员配置
  saveShxy,//社会效益
  getDeptList
} from "@/requst/api";
import {ElMessage} from "element-plus";
import Compressor from "compressorjs";
import 'element-ui/lib/theme-chalk/icon.css';

export default {
  name: 'BaoBei',
/*  components: {
      Plus
  },*/
  data() {
    return {
        bxzzTip: "(1)学习贯彻民办教育法律法规，办学宗旨明确，坚持社会主义办学方向和公益性质，全面贯彻党的教育方针，\n" +
            "落实立德树人根本任务，实施素质教育，满足个性化需求。\n达到得3分，未达到0分",
        bxmbTip:"(1)办学目标明确，有详细的培训课程及计划，及时进行总结提高。\n达到得2分，未达到0分",
        ddjsTip:"(1)按要求建立党组织（单独建、联合建、挂靠建或派驻党建指导员），宣传和执行党的路线、方针、政策，" +
            "认真贯彻落实党中央、上级党组织和本级党组织的决议；\n(2)围绕机构中心任务，增强党组织的凝聚力和战斗力，充分发挥党支部的战斗堡垒作用和党员的先锋模范作用；\n(3)加强对党员的教育、管理和监督，提高党员素质，增强党性；\n(4)组织好政治理论、业务知识的学习，监督党员切实履行义务，保障党员权利不受侵犯；\n(5)对要求入党的积极分子进行培养，做好发展党员工作。" +
            "\n组织健全，活动开展正常有序的得 5 分，每缺1项扣1分",
        yyzzTip:"证件齐全并在有效期内得1分，否则得0分",
        bagsTip:"(1)能够将招生简章、培训教材及相关资料、视频等及时报属地体育及教育行政部门备案并按要求公示；\n(2)按规定签订中小学生校外培训服务合同，并在机构留存备案。\n达到得2分，未达到得0分",
        bxnrTip:"(1)办学规模、办学形式、办学层次、培训范围等项目符合办学许可范围，并按照要求公示。\n达到得2分，未达到得0分",
        jbzxzTip:"(1)举办者应具有法人资格，须信用状况良好，无违法犯罪行为，未被列入经营（运营）异常名录或严重违法失信名单；\n(2)举办者为自然人的应具有中华人民共和国国籍，在" +
            "中国境内定居，信用状况良好，无犯罪记录，有政治权利和完全民事行为能力。年龄不超过 70 岁；\n(3)有两个以上举办者的，应当有合作办学协议并明确举办者的出资数额、出资方式、权利义务、举办者的排序、争议解决办法等内容。\n每项得1分",
        jgmcTip:"(1)机构名称应符合河北省非学科类校外培训机构设置标准（试行）中规定的机构名称相关要求。\n符合得1分，不符合得0分。",
        gzzdTip:"(1)机构的决策管理机构（董事会）应由举办者或其代表人、党组织负责人、行政负责人、教职工代表等五人以上组成。其中，三分之一以上的人员应当具有五年以上教学经验；\n(2)负责人具有相应的资质、学历、职称和五年以上管" +
            "理工作经历；\n(3)负责人应当品行良好，具有政治权利和完全民事行为能力；现职及退休不满三年的公务员不得担任董事会成员。\n每项得1分",
        ssdqTip:"(1)产权明晰，属于租用场地校舍办学的，须有两年以上有效租用合同；\n(2)不得使用临时性简易建筑、危房、厂房、居民住宅、地下室、车库等不适合办学或有安全隐患的场地；\n(3)教学用房建筑面积不少于办学场所总建筑面积的2/3；" +
            "\n(4)培训机构校舍原则上不能超过楼栋的第五层楼；\n(5)取得消防验收合格证或联合勘验合格证明。\n符合得3分， 1项不符合不得分。",
        aqzdTip:"(1)设置消防安全标志，保证疏散通道、安全出口和消防车通道畅通；各个部位配备的灭火器、消防栓等设施定期检查并及时更换；员工能正确熟练使用灭火器和消防栓；用电设施安全，线路规范；\n符合得1分，不符合得0分",
        ygaqxgzmTip:"(1)安装监控设备，培训场所和培训过程监控全覆盖、无死角；视频监控资料存储不少于 30 天。(2)卫生防疫硬件设施配备齐全，卫生防疫物资充足，\n" +
            "制度健全，定期消杀；危险化学物品按规定存放，并建立规范的管理制度。\n每项得1分。",
        ywczyaTip:"(1)制定各类应急预案，常态开展隐患排查、整改和应急演练。\n符合得1分，不符合得0分。",
        szllTip:"(1)有相对稳定的专职师资队伍，并接受家长及社会的监督。专职教师数不得低于机构从业人员总数的 50%。\n(2)教育教学管理人员应具有大学专科以上学历和1年" +
            "以上相关工作经历。\n(3)聘任的专职校长应具有相应的资质、学历、职称和丰富的管理工作经验，人员变动时及时向主管部门备案。\n(4)聘任外籍教师从教的需取得相关部门审批和备案。\n(5)教师档案齐全，业务情况有记录，建立教师评价体" +
            "系和奖惩机制，建立以校本培训为主的教师继续教育制度，全员培训每年不少于 5 次。\n(6)与聘用教师签订规范的劳动合同，工资和福利待遇按时发放到位。\n每项得1分",
        sftfTip:"(1)提前公示收费标准、收费项目和退费办法。\n(2)不得违反收费规定行为。\n(3)不得将学费缴入个人账户，不得抽逃、挪用注册资金和学费收入。" +
            "\n(4)不得向培训对象摊派费用或集资。\n(5)按规定及时向学员退费。\n符合得满分，有一项不符合不得分。",
        zjjgTip:"(1)按规定缴纳注册资金，聘请具有会计从业资格的专业人员担任（兼职）会计和出纳，会计和出纳不得兼任。\n(2)每个会计年度结束时制作财务会计报告。" +
            "\n(3)依法进行审计，并公开审计结果，资产的使用和财务管理接受教育行政部门和其他有关部门的监督。\n(4)按要求纳入全国校外教育培训监管与服务综合平台实现全流程监管，并严格遵守资金使用管理规定。\n前三项每项1分，第四项2分。",
        fgzxTip:"(1)不得通过电话、短信、微信等方式对家长和学生进行培训营销，违规发布各类广告，虚假宣传，以及到中小学校内进行招生宣传。\n(2)不得在违反规定的时间内进行培训。\n(3)不得举办、承办、协办以及组织、诱导学生参加非" +
            "政府部门举办或认可的竞赛、考级活动行为；不得为上述竞赛或活动提供场地设施、宣传渠道、培训、考务服务。\n(4)不得聘用在职中小学教师到培训机构兼职任教。\n(5)学员管理到位，有学员花名册，点名制度，有学员入学、退学登记制度，手续完整。\n每项 1 分。",
        bxcsmjTip:"(1)机构办学场所面积在 300-400 平方米的，得 2 分；\n(2)机构办学场所面积在 400-500 平方米的，得 4 分；\n(3)机构办学场所面积在 500 平方米以上的，得 6 分。",
        yljjypTip:"场地设有医务室、AED 等医疗配备、医疗急救箱或其它医疗设施设备，得 2 分。",
        sjjlTip:"机构聘有省级退役级运动员或聘有具备高级职称的教练员，得 2 分。",
        qzjlTip:"机构全职教练员教学经验超过 3 年及以上的，每位教练得 1 分，累计不超过 4 分。",
        kcyfTip:"机构有专职的课程教研团队或有自主研发的教学培训课程，符合得 2 分。",
        jjryTip:"有 2 位及以上有急救培训资质的工作人员，符合得 1 分。",
        abryTip:"有 2 位及以上有安保培训资质的工作人员，符合得 1 分。",
        ywpxryTip:"(1)机构人员三年内参加市级体育或教育部门组织的相关业务培训，取得合格证书的，每人 1 分，累计不超过 3 分；" +
            "\n(2)机构人员三年内参加省级及以上体育或教育部门组织的相关业务培训，取得合格证书的，每人 1 分，累计不超过 3 分。",
        jlryTip:"全职教练团队人数 3-5 人，得 2 分；6-10 人，得 4 分；11 人及以上，得 6 分。",
        ryjlTip:"机构三年内获得市级以上行政部门荣誉奖励的，得 2 分。",
        qzkbTip:"机构经营年限长（一般指 5 年以上），在当地有较好的群众口碑，得 2 分。",
        sszzTip:"机构年均组织赛事活动 5 场及以上或参与总人数超过 200 人，得 2 分。",
        csryTip:"(1)三年内机构组队参加县级以上综合运动会或单项比赛，每人次 1 分，累计不超过2 分；" +
            "\n(2)三年内机构组队参赛获得省级前八名的或市级前三名，每人次 1 分，累计不超过2 分；" +
            "\n(3)三年内机构组队参赛获得省级前三名，每人次 2 分，累计不超过 4 分。",
        ydryTip:"三年内机构为市级及以上运动队输送运动员的，每人次 1 分，累计不超过 2 分。",
        xcbdTip:"三年内机构获得市级以上官方媒体正面宣传报道 2 次及以上的，得 2 分。",
        gyhdTip:"机构每年自行组织开展公益活动或免费提供场所举办公益活动的，得 2 分。",

      updateDisable:false,
      updateDisableTips:'',
      yyzz1: false,
      yyzz2: false,
      type: 1,// 进度
      baseUrl: '',//图形验证码
      provinceArry: {},
      cityArry: {},
      districtArry: {},
      form1: {
        orgId: '',
        bxzz: '',//办学宗旨材料
        bxzzSelfScore: '',//办学宗旨自评分
        bxmb: '',//办学目标材料
        bxmbSelfScore: '',//办学目标自评分
        ddjs: '',//党的建设材料
        ddjsSelfScore: '',//党的建设自评分
        jbzxzType: '',//举办者性质
        fdzz: '',//法定资质材料
        fdzzSelfScore: '',//法定资质自评分
        bags: '',//备案公示材料
        bagsSelfScore: '',//备案公示自评分
        bxnr: '',//办学内容材料
        bxnrSelfScore: '',//办学内容自评分
      },
      form2: {
          szllList: [],
          jbzList:[],
      },
      szll:{
          "orgId":localStorage.getItem('orgId'),
          "jsxm": "",//教师姓名
          "jssfzh": "",//教师身份证号
          "jssfzz":"",
          "jssfzf":"",
          "jsdlht":"",
          "jscyzgzs":"",
      },
      jbz:{
          "orgId":localStorage.getItem('orgId'),
          "jbzxzType": "",//jbzxzType
          "yyzz": "",//营业执照材料
          "xyzgjt":"",//信用中国截图
          "creditCode":"",//社会统一代码
          "frxm":"",//法人姓名
          "sfzh":"",//身份证号
          "sfzz":"",//身份证正面照片
          "sfzf":"",//身份证反面照片
          "wfzzm":"",//无犯罪证明
          "hzxy":""//合作协议
      },
      form3: {
          token: "",
      },
      form4: {
          token: "",
          yljjypList: [
          ]
      },
      yljjyp:{
          "orgId":localStorage.getItem('orgId'),
          "name": "",//医药用品名称
          "img": "",//医药用品照片
      },
      sjjl:{
          "orgId":localStorage.getItem('orgId'),
          "name": "",//教练姓名
          "idCardNo": "",//教练身份证号码
          "idCardZ": "",//教练身份证正面照片
          "idCardF": "",//教练身份证反面照片
        },
      qzjl: {
          "orgId":localStorage.getItem('orgId'),
          "name": "",//教练姓名
          "idCardNo": "",//教练身份证号码
          "idCardZ": "",//教练身份证正面照片
          "idCardF": "",//教练身份证反面照片
        },
      kcyf:{
          "orgId":localStorage.getItem('orgId'),
          "name": "",//教师姓名
          "zw": "",//教师职务
          "zs": "",//教师研发成果
        },
    jjry: {
          "orgId":localStorage.getItem('orgId'),
          "name": "",//急救人员姓名
          "idCardNo":"",//急救人员身份证号
          "zs": "",//急救人员证书
        },
    abry: {
          "orgId":localStorage.getItem('orgId'),
          "name": "",//安保人员姓名
          "idCardNo":"",//安保人员身份证号
          "zs": "",//安保人员证书
        },
     ywpxry: {
          "orgId":localStorage.getItem('orgId'),
          "name": "",//业务培训人员姓名
          "idCardNo":"",//业务培训人员身份证号
          "zs": "",//业务培训人员证书
        },
      jlry: {
          "orgId":localStorage.getItem('orgId'),
          "name": "",//教练人员姓名
          "idCardNo":"",//教练人员身份证号
          "zs": "",//教练人员证书
        },
      form5:{
          //省级退役/高级职称教练员
          sjjlList: [],
          //3年以上经验全职教练
          qzjlList: [],
          //课程研发
          kcyfList: [],
          //急救人员
          jjryList: [],
          //安保人员
          abryList: [],
          //业务培训人员
          ywpxryList: [],
          //教练人员
          jlryList: [],
      },
      csry: {
          "orgId":localStorage.getItem('orgId'),
          "name": "",//参赛人员姓名
          "idCardNo":"",//参赛人员身份证号
          "csryTp": "",//参赛人员证书
      },
      ydry: {
          "orgId":localStorage.getItem('orgId'),
          "name": "",//运动员姓名
          "idCardNo":"",//运动员身份证号
      },
      xcbd: {
          "orgId":localStorage.getItem('orgId'),
          "xcbdTime": "",//宣传报道时间
          "xcbdTp":"",//宣传报道图片
      },
      gyhd: {
          "orgId":localStorage.getItem('orgId'),
          "gyhdTime": "",//公益活动时间
          "gyhdTp":"",//公益活动图片
      },
      form6:{
          csryList:[],//参赛人员
          ydryList:[],//运动员
          xcbdList:[],//宣传报道
          gyhdList:[]//公益活动
      },
      jbzxz: [
        {
          id: 1,
          label: '营业执照'
        }, {
          id: 2,
          label: '民办非企业单位登记证书'
        }
      ],
      jbzxzArr: [
          {
              id: 1,
              label: '自然人'
          }, {
              id: 2,
              label: '企业单位'
          }
      ],

      icon: 0,
      iconv: '',
      dellist:[],
      siteTypeArry: [
        {
          id: 1,
          label: '自有房屋产权'
        }, {
          id: 2,
          label: '租赁房屋'
        }],
    }
  },


  created() {
    //所属城市列表
    this.getProvinceList(0);
    //this.changeDept(0, 0);
    this.updateDisable = (localStorage.getItem('scoreAuditStatus') == 0 || localStorage.getItem('scoreAuditStatus') == 1) ? false : true
    console.log(this.updateDisable)
    if(this.updateDisable){
        if(localStorage.getItem('scoreAuditStatus') == 2 || localStorage.getItem('scoreAuditStatus') == 4){
            this.updateDisableTips = "自评分审核中，无法修改...";
        }
        if(localStorage.getItem('scoreAuditStatus') == 3){
            this.updateDisableTips = "自评分已审核，无法修改...";
        }
    }


    this.type =  parseInt(localStorage.getItem('type')) ? parseInt(localStorage.getItem('type')) : 1
    switch (this.type) {
      case 1:
        if(localStorage.getItem('form1')){
            this.form1 = JSON.parse(localStorage.getItem('form1')) ? JSON.parse(localStorage.getItem('form1')) : this.form1
            if(this.form1.jbzxzType){
                this.form1.jbzxzType = parseInt(this.form1.jbzxzType)
            }
        }else{
            this.form1.jbzxzType = ''
        }
        break;
      case 2:
        if(localStorage.getItem('form2')){
            this.form2 = JSON.parse(localStorage.getItem('form2')) ? JSON.parse(localStorage.getItem('form2')) : this.form2
            this.form2.jbzxzType = parseInt(this.form2.jbzxzType)
            if(this.form2.jbzxzType == 2){
                this.yyzz2 = true;
            }
            if(this.form2.cdxz){
                this.form2.cdxz = parseInt(this.form2.cdxz)
            }

        }
        break;
      case 3:
        if(localStorage.getItem('form3')){
            this.form3 = JSON.parse(localStorage.getItem('form3')) ? JSON.parse(localStorage.getItem('form3')) : this.form3
        }
        break;
      case 4:
        if(localStorage.getItem('form4')){
            this.form4 = JSON.parse(localStorage.getItem('form4')) ? JSON.parse(localStorage.getItem('form4')) : this.form4
            if(this.form4.yljjypList.length==0){
                this.form4.yljjypList.push({name:'',img:''})
            }
        }
        break;
      case 5:
        if(localStorage.getItem('form5')){
            this.form5 = JSON.parse(localStorage.getItem('form5')) ? JSON.parse(localStorage.getItem('form5')) : this.form5
        }
          break;
      case 6:
        if(localStorage.getItem('form6')){
            this.form6 = JSON.parse(localStorage.getItem('form6')) ? JSON.parse(localStorage.getItem('form6')) : this.form6
        }

    }
  },
    mounted(){
        this.getCityList(this.form2.province);
        this.getDistrictList(this.form2.city);
    },
  methods: {
    //校验身份证号
    validIDCardNo(idCardNo){
        var reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if(idCardNo.match(reg)){
          return true;
        }
        return false;
    },
    //校验手机号
    validPhone(phone){
        var reg = /^1[3-9]\d{9}$/;
        if (reg.test(phone)) {
            return true;
        }
        return false;
    },
    validNumber(e){
        // 通过正则过滤小数点后两位
        e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
    },
    pickerOptions(time) {
        return time.getTime() > Date.now();
    },
    getstr() {
      this.icon = parseInt(new Date().getTime())
      return this.icon;
    },

    changeBoundary1(e) {
        if (e == 1) {
            this.yyzz1 = true
        } else {
            this.yyzz1 = false
        }
    },
    changeBoundary2(e) {
        if (e == 2) {
            this.yyzz2 = true
        } else {
            this.yyzz2 = false
        }
    },

    inputnow() {
      localStorage.setItem('form1', JSON.stringify(this.form1))
      localStorage.setItem('form2', JSON.stringify(this.form2))
      localStorage.setItem('form3', JSON.stringify(this.form3))
      localStorage.setItem('form4', JSON.stringify(this.form4))
      localStorage.setItem('form5', JSON.stringify(this.form5))
      localStorage.setItem('form6', JSON.stringify(this.form6))
    },
    beforeUploadFile(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!extension) {
        ElMessage.error('格式错误')
        return false
      }
    },
    beforeUploadFile1(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!extension) {
        ElMessage.error('格式错误')
        return false
      }
    },
    //上传文件
    customUpload1(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      console.log(file.file)
      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('file', filess);
            _this.$http.post('/api/file/uploadQny', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.msg
              if (file.filename == 'bxzz') {
                _this.form1.bxzz = str
              }
              if (file.filename == 'bxmb') {
                _this.form1.bxmb = str
              }
              if (file.filename == 'ddjs') {
                _this.form1.ddjs = str
              }
              if (file.filename == 'fdzz') {
                _this.form1.fdzz = str
              }
              if (file.filename == 'bags') {
                _this.form1.bags = str
              }
              if (file.filename == 'bxnr') {  //办学内容
                _this.form1.bxnr = str
              }
              localStorage.setItem('form1', JSON.stringify(_this.form1))
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('file', file.file);
        _this.$http.post('/api/file/uploadQny', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          loading.close();
          let str = response.data.msg
            if (file.filename == 'bxzz') {
                _this.form1.bxzz = str
            }
            if (file.filename == 'bxmb') {
                _this.form1.bxmb = str
            }
            if (file.filename == 'ddjs') {
                _this.form1.ddjs = str
            }
            if (file.filename == 'fdzz') {
                _this.form1.fdzz = str
            }
            if (file.filename == 'bags') {
                _this.form1.bags = str
            }
            if (file.filename == 'bxnr') {  //办学内容
                _this.form1.bxnr = str
            }
          localStorage.setItem('form1', JSON.stringify(_this.form1))
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }

    },
    customUpload2(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('file', filess);
            _this.$http.post('/api/file/uploadQny', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.msg
              if (file.filename === 'yyzz') {
                _this.jbz.yyzz = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'xyzgjt') {
                  _this.jbz.xyzgjt = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'sfzz') {
                  _this.jbz.sfzz = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'sfzf') {
                  _this.jbz.sfzf = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'wfzzm') {
                  _this.jbz.wfzzm = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'hzxy') {
                  _this.jbz.hzxy = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'gzzd') {
                  _this.form2.gzzd = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'cqzm') {
                  _this.form2.cqzm = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'xfzm') {
                  _this.form2.xfzm = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'fwaqjds') {
                  _this.form2.fwaqjds = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'aqzd') {
                  _this.form2.aqzd = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'ygaqxgzm') {
                  _this.form2.ygaqxgzm = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'ywczya') {
                  _this.form2.ywczya = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.data.name === 'jssfzz') {
                  _this.szll.jssfzz = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.data.name === 'jssfzf') {
                  _this.szll.jssfzf = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.data.name === 'jsldht') {
                  _this.szll.jsldht = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.data.name === 'jscyzgzs') {
                  _this.szll.jscyzgzs = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('file', file.file);
        _this.$http.post('/api/file/uploadQny', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
            loading.close();
            let str = response.data.msg
            if (file.filename === 'yyzz') {
                _this.jbz.yyzz = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'xyzgjt') {
                _this.jbz.xyzgjt = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'sfzz') {
                _this.jbz.sfzz = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'sfzf') {
                _this.jbz.sfzf = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'wfzzm') {
                _this.jbz.wfzzm = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'hzxy') {
                _this.jbz.hzxy = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'gzzd') {
                _this.form2.gzzd = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'cqzm') {
                _this.form2.cqzm = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'xfzm') {
                _this.form2.xfzm = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'fwaqjds') {
                _this.form2.fwaqjds = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'aqzd') {
                _this.form2.aqzd = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'ygaqxgzm') {
                _this.form2.ygaqxgzm = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.filename === 'ywczya') {
                _this.form2.ywczya = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.data.name === 'jssfzz') {
                _this.szll.jssfzz = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.data.name === 'jssfzf') {
                _this.szll.jssfzf = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.data.name === 'jsldht') {
                _this.szll.jsldht = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
            if (file.data.name === 'jscyzgzs') {
                _this.szll.jscyzgzs = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }
    },
    customUpload3(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });

      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('file', filess);
            _this.$http.post('/api/file/uploadQny', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.msg
              if (file.filename === 'sftf') {
                  _this.form3.sftf = str
                  localStorage.setItem('form3', JSON.stringify(_this.form3))
              }
              if (file.filename === 'zjjg') {
                  _this.form3.zjjg = str
                  localStorage.setItem('form3', JSON.stringify(_this.form3))
              }
              if (file.filename === 'fgzx') {
                  _this.form3.fgzx = str
                  localStorage.setItem('form3', JSON.stringify(_this.form3))
              }
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('file', file.file);
        _this.$http.post('/api/file/uploadQny', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
            loading.close();
            let str = response.data.msg
            if (file.filename === 'sftf') {
                _this.form3.sftf = str
                localStorage.setItem('form3', JSON.stringify(_this.form3))
            }
            if (file.filename === 'zjjg') {
                _this.form3.zjjg = str
                localStorage.setItem('form3', JSON.stringify(_this.form3))
            }
            if (file.filename === 'fgzx') {
                _this.form3.fgzx = str
                localStorage.setItem('form3', JSON.stringify(_this.form3))
            }
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }

    },
    customUpload4(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      let _this = this
      console.log(file.file.name.split('.')[1])
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('file', filess);
            _this.$http.post('/api/file/uploadQny', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.msg

              if (file.filename === 'bxcsmj') {
                  _this.form4.bxcsmj = str
                  localStorage.setItem('form4', JSON.stringify(_this.form4))
              }
              if (file.data.name === 'yljjyp') {
                  _this.yljjyp.img = str
                  localStorage.setItem('form4', JSON.stringify(_this.form4))
              }
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('file', file.file);
        _this.$http.post('/api/file/uploadQny', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
            loading.close();
            let str = response.data.msg

            if (file.filename === 'bxcsmj') {
                _this.form4.bxcsmj = str
                localStorage.setItem('form4', JSON.stringify(_this.form4))
            }
            if (file.data.name === 'yljjyp') {
                _this.yljjyp.img = str
                localStorage.setItem('form4', JSON.stringify(_this.form4))
            }
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }
    },
    customUpload5(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('file', filess);
            _this.$http.post('/api/file/uploadQny', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.msg
              console.log(file.data.name)

              if (file.data.name === 'sjjlIdCardNoZ') {
                  _this.sjjl.idCardZ = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }
              if (file.data.name === 'sjjlIdCardNoF') {
                  _this.sjjl.idCardF = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }
              if (file.data.name === 'qzjlIdCardNoZ') {
                  _this.qzjl.idCardZ = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }
              if (file.data.name === 'qzjlIdCardNoF') {
                  _this.qzjl.idCardF = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }
              if (file.data.name === 'yfcgzs') {
                  _this.kcyf.zs = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }
              if (file.data.name === 'jjryzs') {
                  _this.jjry.zs = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }
              if (file.data.name === 'abryzs') {
                  _this.abry.zs = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }
              if (file.data.name === 'ywpxryzs') {
                  _this.ywpxry.zs = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }
              if (file.data.name === 'jlryzs') {
                  _this.jlry.zs = str
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
              }

            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('file', file.file);
        _this.$http.post('/api/file/uploadQny', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
            loading.close();
            let str = response.data.msg
            console.log(file.data.name)

            if (file.data.name === 'sjjlIdCardNoZ') {
                _this.sjjl.idCardZ = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }
            if (file.data.name === 'sjjlIdCardNoF') {
                _this.sjjl.idCardF = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }
            if (file.data.name === 'qzjlIdCardNoZ') {
                _this.qzjl.idCardZ = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }
            if (file.data.name === 'qzjlIdCardNoF') {
                _this.qzjl.idCardF = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }
            if (file.data.name === 'yfcgzs') {
                _this.kcyf.zs = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }
            if (file.data.name === 'jjryzs') {
                _this.jjry.zs = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }
            if (file.data.name === 'abryzs') {
                _this.abry.zs = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }
            if (file.data.name === 'ywpxryzs') {
                _this.ywpxry.zs = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }
            if (file.data.name === 'jlryzs') {
                _this.jlry.zs = str
                localStorage.setItem('form5', JSON.stringify(_this.form5))
            }

        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }
    },
    customUpload6(file) {
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        });
        let _this = this
        let wz = file.file.name.split('.')[1];
        if (wz == 'jpg' || wz == 'png') {
            new Compressor(file.file, {
                quality: 0.1,
                success(result) {
                    let filess = new File([result], file.file.name, {type: file.file.type})
                    console.log(result)
                    var FormDatas = new FormData();
                    FormDatas.append('file', filess);
                    _this.$http.post('/api/file/uploadQny', FormDatas, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                        loading.close();
                        let str = response.data.msg
                        console.log(str)
                        if (file.filename === 'ryjl') {
                            _this.form6.ryjl = str
                            localStorage.setItem('form6', JSON.stringify(_this.form6))
                        }
                        if (file.filename === 'sszz') {
                            _this.form6.sszz = str
                            localStorage.setItem('form6', JSON.stringify(_this.form6))
                        }
                        if (file.data.name === 'csryTp') {
                            _this.csry.csryTp = str
                            localStorage.setItem('form6', JSON.stringify(_this.form6))
                        }
                        if (file.data.name === 'xcbdTp') {
                            _this.xcbd.xcbdTp = str
                            localStorage.setItem('form6', JSON.stringify(_this.form6))
                        }
                        if (file.data.name === 'gyhdTp') {
                            _this.gyhd.gyhdTp = str
                            localStorage.setItem('form6', JSON.stringify(_this.form6))
                        }

                        localStorage.setItem('form6', JSON.stringify(_this.form6))

                    }).catch(e => {
                        loading.close();
                        ElMessage.error('上传失败')
                        console.log(e)
                    })
                },
                error(err) {
                    //错误处理
                    console.log(err.message)
                }
            })
        } else {
            let FormDatas = new FormData();
            FormDatas.append('file', file.file);
            _this.$http.post('/api/file/uploadQny', FormDatas, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                loading.close();
                let str = response.data.msg
                console.log(str)
                if (file.filename === 'ryjl') {
                    _this.form6.ryjl = str
                    localStorage.setItem('form6', JSON.stringify(_this.form6))
                }
                if (file.filename === 'sszz') {
                    _this.form6.sszz = str
                    localStorage.setItem('form6', JSON.stringify(_this.form6))
                }
                if (file.data.name === 'csryTp') {
                    _this.csry.csryTp = str
                    localStorage.setItem('form6', JSON.stringify(_this.form6))
                }
                if (file.data.name === 'xcbdTp') {
                    _this.xcbd.xcbdTp = str
                    localStorage.setItem('form6', JSON.stringify(_this.form6))
                }
                if (file.data.name === 'gyhdTp') {
                    _this.gyhd.gyhdTp = str
                    localStorage.setItem('form6', JSON.stringify(_this.form6))
                }


            }).catch(e => {
                loading.close();
                ElMessage.error('上传失败')
                console.log(e)
            })
        }
    },
    goIndex(){
        this.$router.push('/')
    },
    jichutijiao() {
      let _this = this
      window.scrollTo(0, 0);
      switch (this.type) {
        case 1:
          if(localStorage.getItem('form2')){
              this.form2 = JSON.parse(localStorage.getItem('form2')) ? JSON.parse(localStorage.getItem('form2')) : this.form2
              this.form2.jbzxzType = parseInt(this.form2.jbzxzType)
              if(this.form2.jbzxzType == 2){
                  this.yyzz2 = true;
              }
              this.form2.cdxz = parseInt(this.form2.cdxz)
          }

          if(this.updateDisable){
              _this.type = 2
              localStorage.setItem('type', _this.type)
              return false;
          }
          if (!this.form1.bxzz) {
            ElMessage.error('请上传办学宗旨')
            return false;
          }
          if (!this.form1.bxzzSelfScore && this.form1.bxzzSelfScore != 0) {
              ElMessage.error('请对办学宗旨评分')
              return false;
          }

          if (!this.form1.bxmb) {
            ElMessage.error('请上传办学目标')
            return false;
          }

          if (!this.form1.bxmbSelfScore && this.form1.bxmbSelfScore != 0) {
              ElMessage.error('请对办学目标评分')
              return false;
          }

          if (!this.form1.ddjs) {
            ElMessage.error('请上传党的建设')
            return false;
          }
          if (!this.form1.ddjsSelfScore && this.form1.ddjsSelfScore != 0) {
              ElMessage.error('请对党的建设评分')
              return false;
          }
          if (!this.form1.jbzxzType) {
              ElMessage.error('请选择机构类型')
              return false;
          }

          if (this.form1.jbzxzType == 1 && !this.form1.fdzz) {
            ElMessage.error('请上传营业执照')
            return false;
          }
          if (this.form1.jbzxzType == 1 && !this.form1.fdzzSelfScore && this.form1.fdzzSelfScore != 0) {
              ElMessage.error('请对营业执照评分')
              return false;
          }
          if (this.form1.jbzxzType == 2 && !this.form1.fdzz) {
              ElMessage.error('请上传民办非企业单位登记证书照片')
              return false;
          }
          if (this.form1.jbzxzType == 2 && !this.form1.fdzzSelfScore && this.form1.fdzzSelfScore != 0) {
              ElMessage.error('请对民办非企业单位登记证书评分')
              return false;
          }

          if (!this.form1.bags) {
            ElMessage.error('请上传备案公示')
            return false;
          }
          if (!this.form1.bagsSelfScore && this.form1.bagsSelfScore != 0) {
              ElMessage.error('请对备案公示评分')
              return false;
          }
          if (!this.form1.bxnr) {
            ElMessage.error('请上传办学内容')
            return false;
          }
          if (!this.form1.bxnrSelfScore && this.form1.bxnrSelfScore != 0) {
              ElMessage.error('请对办学内容评分')
              return false;
          }
            this.form1.orgId = localStorage.getItem('orgId')
            saveBxfx(this.form1).then(res => {
            if (res.code != 200) {
              ElMessage.error(res.msg)
              return false;
            }
            if (res.code == 200) {

              ElMessage.success(res.msg)
              _this.form1.bxfxId = res.data.id
              _this.form1.token = res.data.token
              localStorage.setItem('bxfxId', res.data.bxfxId)
              localStorage.setItem('token', res.data.token)
              localStorage.setItem('form1', JSON.stringify(this.form1))
              _this.type = 2
              localStorage.setItem('type', _this.type)
            }
          })
          break;
        case 2:
            if(localStorage.getItem('form3')){
              this.form3 = JSON.parse(localStorage.getItem('form3')) ? JSON.parse(localStorage.getItem('form3')) : this.form3
            }

            if(this.updateDisable){
                _this.type = 3
                localStorage.setItem('type', _this.type)
                return false;
            }

           /* if (!this.form2.jbzxzType) {
                ElMessage.error('请选择举办者性质')
                return false;
            }*/
            if (!this.form2.jbzxzSelfScore && this.form2.jbzxzSelfScore != 0) {
                ElMessage.error('请对举办者性质评分')
                return false;
            }
            if(this.form2.sfzh && !this.validIDCardNo(this.form2.sfzh)){
                ElMessage.error('决策机制--身份证号格式错误')
                return false;
            }

            if (!this.form2.gzzdSelfScore && this.form2.gzzdSelfScore != 0) {
                ElMessage.error('请选择规章制度自评分')
                return false;
            }
            if (!this.form2.ssdqSelfScore && this.form2.ssdqSelfScore != 0) {
                ElMessage.error('请选择所属地区自评分')
                return false;
            }
            if (!this.form2.aqzdSelfScore && this.form2.aqzdSelfScore != 0) {
                ElMessage.error('请选择安全制度自评分')
                return false;
            }
            if (!this.form2.ygaqxgzmSelfScore && this.form2.ygaqxgzmSelfScore != 0) {
                ElMessage.error('请选择员工安全相关证明自评分')
                return false;
            }
            if (!this.form2.ywczyaSelfScore && this.form2.ywczyaSelfScore != 0) {
                ElMessage.error('请选择意外处置预案自评分')
                return false;
            }
            if (!this.form2.szllSelfScore && this.form2.szllSelfScore != 0) {
                ElMessage.error('请选择师资力量自评分')
                return false;
            }

          if (!this.form2.szllList.length < 1) {
            if (this.form2.szllList[0].siteArea == '') {
              ElMessage.error('请至少添加一名教师信息')
              return false;
            }
          }
          var errMsg ="";
          this.form2.szllList.forEach(k => {
            if (!k.jsxm) {
              ElMessage.error('请输入教师姓名')
              errMsg = '请输入教师姓名'
              return false;
            }
            if (!k.jssfzh) {
              ElMessage.error('请输入教师身份证号')
              errMsg = '请输入教师身份证号'
              return false;
            }
            if (!this.validIDCardNo(k.jssfzh)) {
                ElMessage.error('师资力量--教师"'+k.jsxm+'"身份证号格式错误')
                errMsg = '师资力量--教师"'+k.jsxm+'"身份证号格式错误'
                return false;
            }
            if (!k.jssfzz) {
              ElMessage.error('请上传教师身份证正面照片')
              errMsg = '请上传教师身份证正面照片'
              return false;
            }
            if (!k.jssfzf) {
              ElMessage.error('请上传教师身份证反面照片')
              errMsg = '请上传教师身份证反面照片'
              return false;
            }
            if (!k.jsldht) {
              ElMessage.error('请上传教师劳动合同')
              errMsg = '请上传教师劳动合同'
              return false;
            }
            if (!k.jscyzgzs) {
                ElMessage.error('请上传从业资格证书')
                errMsg = '请上传从业资格证书'
                return false;
            }
          })
          if(errMsg != ''){
              ElMessage.error(errMsg)
              return false;
          }
          this.form2.orgId = localStorage.getItem('orgId')
          this.form2.token = localStorage.getItem('token')
          this.form2.bxfxId = localStorage.getItem('bxfxId')
          saveBxtj(this.form2).then(res => {
              if (res.code != 200) {
                  ElMessage.error(res.msg)
                  return false;
              }
              if (res.code == 200) {
                  ElMessage.success(res.msg)
                  _this.form2.bxtjId = res.data.bxtjId
                  _this.form2.token = res.data.token
                  localStorage.setItem('bxtjId', res.data.bxtjId)
                  localStorage.setItem('token', res.data.token)
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
                  _this.type = 3
                  localStorage.setItem('type', _this.type)
              }
          })
          break;
        case 3:
          if(localStorage.getItem('form4')){
              this.form4 = JSON.parse(localStorage.getItem('form4')) ? JSON.parse(localStorage.getItem('form4')) : this.form4
          }

          if(this.updateDisable){
              _this.type = 4
              localStorage.setItem('type', _this.type)
              return false;
          }
          if(!this.form3.sftfSelfScore && this.form3.sftfSelfScore != 0){
            ElMessage.error('请选择收费退费自评分')
            return false
          }
          if(!this.form3.zjjgSelfScore && this.form3.zjjgSelfScore != 0){
            ElMessage.error('请选择资金监管自评分')
            return false
          }
          if(!this.form3.fgzxSelfScore && this.form3.fgzxSelfScore != 0){
              ElMessage.error('请选择法规执行自评分')
              return false
          }
          this.form3.orgId = localStorage.getItem('orgId')
          this.form3.token = localStorage.getItem('token')
          this.form3.bxtjId = localStorage.getItem('bxtjId')
          saveGfbx(this.form3).then(res => {
              if (res.code != 200) {
                  ElMessage.error(res.msg)
                  return false;
              }
              if (res.code == 200) {
                  ElMessage.success(res.msg)
                  _this.form3.gfbxId = res.data.gfbxId
                  _this.form3.token = res.data.token
                  localStorage.setItem('gfbxId', res.data.gfbxId)
                  localStorage.setItem('token', res.data.token)
                  localStorage.setItem('form3', JSON.stringify(_this.form3))
                  _this.type = 4
                  localStorage.setItem('type', _this.type)
              }
          })
          break;
        case 4:
          if(localStorage.getItem('form5')){
              this.form5 = JSON.parse(localStorage.getItem('form5')) ? JSON.parse(localStorage.getItem('form5')) : this.form5
          }
          if(this.updateDisable){
              _this.type = 5
              localStorage.setItem('type', _this.type)
              return false;
          }
          if(!this.form4.bxcsmjSelfScore && this.form4.bxcsmjSelfScore != 0){
              ElMessage.error('请选择办学场所面积自评分')
              return false
          }
          if(!this.form4.yljjypSelfScore && this.form4.yljjypSelfScore != 0){
              ElMessage.error('请选择医疗急救用品自评分')
              return false
          }
          this.form4.orgId = localStorage.getItem('orgId')
          this.form4.token = localStorage.getItem('token')
          this.form4.gfbxId = localStorage.getItem('gfbxId')
          saveCsqk(this.form4).then(res => {
              if (res.code != 200) {
                  ElMessage.error(res.msg)
                  return false;
              }
              if (res.code == 200) {
                  ElMessage.success(res.msg)
                  _this.form4.csqkId = res.data.csqkId
                  _this.form4.token = res.data.token
                  localStorage.setItem('csqkId', res.data.csqkId)
                  localStorage.setItem('token', res.data.token)
                  localStorage.setItem('form4', JSON.stringify(_this.form4))
                  _this.type = 5
                  localStorage.setItem('type', _this.type)
              }
          })

          break;
        case 5:
          var errMessage ="";
          if(localStorage.getItem('form6')){
              this.form6 = JSON.parse(localStorage.getItem('form6')) ? JSON.parse(localStorage.getItem('form6')) : this.form6
          }
          if(this.updateDisable){
              _this.type = 6
              localStorage.setItem('type', _this.type)
              return false;
          }
          if(!this.form5.sjjlSelfScore && this.form5.sjjlSelfScore != 0){
              ElMessage.error('请选择省级退役/高级职称教练员自评分')
              return false
          }
          console.log(this.form5.sjjlList)
          this.form5.sjjlList.forEach(k => {
              if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                  ElMessage.error('省级教练"'+k.name+'"身份证号格式错误')
                  errMessage = '省级教练"'+k.name+'"身份证号格式错误'
                  return false;
              }
          })
          if(errMessage != ''){
              ElMessage.error(errMessage)
              return false;
          }
          if(!this.form5.qzjlSelfScore && this.form5.qzjlSelfScore != 0){
              ElMessage.error('请选择3年经验以上全职教练自评分')
              return false
          }
          this.form5.qzjlList.forEach(k => {
              if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                  ElMessage.error('全职教练"'+k.name+'"身份证号格式错误')
                  errMessage = '全职教练"'+k.name+'"身份证号格式错误'
                  return false;
              }
          })
          if(errMessage != ''){
              ElMessage.error(errMessage)
              return false;
          }
          if(!this.form5.kcyfSelfScore && this.form5.kcyfSelfScore != 0){
              ElMessage.error('请选择课程研发自评分')
              return false
          }
          this.form5.kcyfList.forEach(k => {
              if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                  ElMessage.error('课程研发人员"'+k.name+'"身份证号格式错误')
                  errMessage = '课程研发人员"'+k.name+'"身份证号格式错误'
                  return false;
              }
          })
          if(errMessage != ''){
              ElMessage.error(errMessage)
              return false;
          }
          if(!this.form5.jjrySelfScore && this.form5.jjrySelfScore != 0){
              ElMessage.error('请选择急救人员自评分')
              return false
          }
          this.form5.jjryList.forEach(k => {
              if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                  ElMessage.error('急救人员"'+k.name+'"身份证号格式错误')
                  errMessage = '急救人员"'+k.name+'"身份证号格式错误'
                  return false;
              }
          })
          if(errMessage != ''){
              ElMessage.error(errMessage)
              return false;
          }
          if(!this.form5.abrySelfScore && this.form5.abrySelfScore != 0){
              ElMessage.error('请选择安保人员自评分')
              return false
          }

          this.form5.abryList.forEach(k => {
              if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                  ElMessage.error('安保人员"'+k.name+'"身份证号格式错误')
                  errMessage = '安保人员"'+k.name+'"身份证号格式错误'
                  return false;
              }
          })
          if(errMessage != ''){
              ElMessage.error(errMessage)
              return false;
          }
          if(!this.form5.ywpxrySelfScore && this.form5.ywpxrySelfScore != 0){
              ElMessage.error('请选择业务培训人员自评分')
              return false
          }
          this.form5.ywpxryList.forEach(k => {
              if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                  ElMessage.error('业务培训人员"'+k.name+'"身份证号格式错误')
                  errMessage = '业务培训人员"'+k.name+'"身份证号格式错误'
                  return false;
              }
          })
          if(errMessage != ''){
              ElMessage.error(errMessage)
              return false;
          }

          if(!this.form5.jlrySelfScore && this.form5.jlrySelfScore != 0){
              ElMessage.error('请选择教练人员自评分')
              return false
          }
          this.form5.jlryList.forEach(k => {
              if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                  ElMessage.error('教练人员"'+k.name+'"身份证号格式错误')
                  errMessage = '教练人员"'+k.name+'"身份证号格式错误'
                  return false;
              }
          })
          if(errMessage != ''){
              ElMessage.error(errMessage)
              return false;
          }

          this.form5.orgId = localStorage.getItem('orgId')
          this.form5.token = localStorage.getItem('token')
          this.form5.csqkId = localStorage.getItem('csqkId')
          saveRypz(this.form5).then(res => {
              if (res.code != 200) {
                  ElMessage.error(res.msg)
                  return false;
              }
              if (res.code == 200) {
                  ElMessage.success(res.msg)
                  _this.form5.rypzId = res.data.rypzId
                  _this.form5.token = res.data.token
                  localStorage.setItem('rypzId', res.data.rypzId)
                  localStorage.setItem('token', res.data.token)
                  localStorage.setItem('form5', JSON.stringify(_this.form5))
                  _this.type = 6
                  localStorage.setItem('type', _this.type)
              }
          })
          break;
        case 6:
              if(this.updateDisable){
                  _this.type = 1
                  localStorage.setItem('type', _this.type)
                  this.$router.push('/')
                  return false;
              }
              if(!this.form6.ryjlSelfScore && this.form6.ryjlSelfScore != 0){
                  ElMessage.error('请选择荣誉奖励自评分')
                  return false
              }
              if(!this.form6.qzkbSelfScore && this.form6.qzkbSelfScore != 0){
                  ElMessage.error('请选择群众口碑自评分')
                  return false
              }
              if(!this.form6.sszzSelfScore && this.form6.sszzSelfScore != 0){
                  ElMessage.error('请选择赛事组织自评分')
                  return false
              }
              if(!this.form6.csrySelfScore && this.form6.csrySelfScore != 0){
                  ElMessage.error('请选择参赛人员自评分')
                  return false
              }
              var errMsgs = '';
              this.form6.csryList.forEach(k => {
                  if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                      ElMessage.error('参赛人员"'+k.name+'"身份证号格式错误')
                      errMsgs = '参赛人员"'+k.name+'"身份证号格式错误'
                      return false;
                  }
              })
              if(errMsgs != ''){
                  ElMessage.error(errMsgs)
                  return false;
              }
              if(!this.form6.ydrySelfScore && this.form6.ydrySelfScore != 0){
                  ElMessage.error('请选择运动员输送自评分')
                  return false
              }
              this.form6.ydryList.forEach(k => {
                  if (k.idCardNo && !this.validIDCardNo(k.idCardNo)) {
                      ElMessage.error('运动员"'+k.name+'"身份证号格式错误')
                      errMsgs = '运动员"'+k.name+'"身份证号格式错误'
                      return false;
                  }
              })
              if(errMsgs != ''){
                  ElMessage.error(errMsgs)
                  return false;
              }
              if(!this.form6.xcbdSelfScore && this.form6.xcbdSelfScore != 0){
                  ElMessage.error('请选择宣传报道自评分')
                  return false
              }
              if(!this.form6.gyhdSelfScore && this.form6.gyhdSelfScore != 0){
                  ElMessage.error('请选择公益活动自评分')
                  return false
              }
              this.form6.orgId = localStorage.getItem('orgId')
              this.form6.token = localStorage.getItem('token')
              this.form6.rypzId = localStorage.getItem('rypzId')
              saveShxy(this.form6).then(res => {
                  if (res.code != 200) {
                      ElMessage.error(res.msg)
                      return false;
                  }
                  if (res.code == 200) {
                      ElMessage.success(res.msg)
                      _this.form6.shxyId = res.data.shxyId
                      _this.form6.token = res.data.token
                      localStorage.setItem('shxyId', res.data.shxyId)
                      localStorage.setItem('token', res.data.token)
                      localStorage.setItem('form6', JSON.stringify(_this.form6))
                      console.log(res.data.orgInfo)
                      localStorage.setItem('selfScoreTotal', res.data.orgInfo.selfScoreTotal);
                      //localStorage.setItem('starLevel', res.data.orgInfo.starLevel);
                      localStorage.setItem('orgName',res.data.orgInfo.orgName);
                      setTimeout(function () {
                          _this.$router.push('/scoreSuccess')
                      }, 500)
                      /*_this.type = 1
                      localStorage.setItem('type', _this.type)
                      this.$router.push('/')*/
                  }
              })
              break;
      }
    }
    ,
      jichutijiao1() {
          // _this = this
          window.scrollTo(0, 0);
          console.log(1)
          switch (this.type) {
              case 1:
                  this.type = 1
                  break;
              case 2:
                  this.form1 = JSON.parse(localStorage.getItem('form1')) ? JSON.parse(localStorage.getItem('form1')) : this.form1
                  this.form1.jbzxzType = parseInt(this.form1.jbzxzType)
                  this.type = 1
                  localStorage.setItem('type', this.type)
                  break;
              case 3:
                  this.form2 = JSON.parse(localStorage.getItem('form2')) ? JSON.parse(localStorage.getItem('form2')) : this.form2
                  this.form2.jbzxzType = parseInt(this.form2.jbzxzType)
                  if(this.form2.jbzxzType == 2){
                      this.yyzz2 = true;
                  }
                  this.form2.cdxz = parseInt(this.form2.cdxz)
                  this.type = 2
                  localStorage.setItem('type', this.type)
                  break;
              case 4:
                  this.form3 = JSON.parse(localStorage.getItem('form3')) ? JSON.parse(localStorage.getItem('form3')) : this.form3
                  this.type = 3
                  localStorage.setItem('type', this.type)
                  break;
              case 5:
                  this.form4 = JSON.parse(localStorage.getItem('form4')) ? JSON.parse(localStorage.getItem('form4')) : this.form4
                  this.type = 4
                  localStorage.setItem('type', this.type)
                  break;
              case 6:
                  this.form5 = JSON.parse(localStorage.getItem('form5')) ? JSON.parse(localStorage.getItem('form5')) : this.form5
                  this.type = 5
                  localStorage.setItem('type', this.type)
                  break;
          }
          localStorage.setItem('type', this.type)
      },

      /*增加jbz*/
      zengjiajbz() {
          let jbzlist = this.form2.jbzList

          if (!this.jbz.jbzxzType) {
              ElMessage.error('请选择举办者性质')
              return false;
          }
          if(this.yyzz2){
              if (!this.jbz.yyzz) {
                  ElMessage.error('请上传营业执照材料')
                  return false;
              }
              if (!this.jbz.xyzgjt) {
                  ElMessage.error('请上传信用中国截图')
                  return false;
              }
              if (!this.jbz.creditCode) {
                  ElMessage.error('请填写社会统一代码')
                  return false;
              }
          }

          if (!this.jbz.frxm) {
              ElMessage.error('请填写法人姓名')
              return false;
          }
          if (!this.jbz.sfzh) {
              ElMessage.error('请填写身份证号')
              return false;
          }
          if (!this.jbz.sfzz) {
              ElMessage.error('请上传身份证正面照片')
              return false;
          }
          if (!this.jbz.sfzf) {
              ElMessage.error('请上传身份证反面照片')
              return false;
          }
          if (!this.jbz.wfzzm) {
              ElMessage.error('请上传无犯罪证明')
              return false;
          }
          if(this.form2.jbzList.length >=1 && !this.jbz.hzxy){
              ElMessage.error('请上传合作协议')
              return false;
          }
          console.log(jbzlist);
          //list.token = localStorage.getItem('token')
          jbzlist.push(this.jbz)
          this.form2.jbzList = jbzlist

          this.jbz={
              "orgId":localStorage.getItem('orgId'),
              "jbzxzType": "",//jbzxzType
              "yyzz": "",//营业执照材料
              "xyzgjt":"",//信用中国截图
              "creditCode":"",//社会统一代码
              "frxm":"",//法人姓名
              "sfzh":"",//身份证号
              "sfzz":"",//身份证正面照片
              "sfzf":"",//身份证反面照片
              "wfzzm":"",//无犯罪证明
              "hzxy":"",//合作协议
          }
      }
      ,
      //删除举办者
      shanchujbz(e) {
          this.form2.jbzList.splice(e, 1)
          localStorage.setItem('form2', JSON.stringify(this.form2))
      }
      ,
    /*增加教师*/
    zengjiajiaoshi() {
      let list = this.form2.szllList

      if (!this.szll.jsxm) {
          ElMessage.error('请输入教师姓名')
          return false;
      }
      if (!this.szll.jssfzh) {
          ElMessage.error('请输入教师身份证号')
          return false;
      }
      if (!this.szll.jssfzz) {
          ElMessage.error('请上传教师身份证正面照片')
          return false;
      }
      if (!this.szll.jssfzf) {
          ElMessage.error('请上传教师身份证反面照片')
          return false;
      }
      if (!this.szll.jsldht) {
          ElMessage.error('请上传教师劳动合同')
          return false;
      }
      if (!this.szll.jscyzgzs) {
          ElMessage.error('请上传教师从业资格证书')
          return false;
      }

      list.token = localStorage.getItem('token')
      list.push(this.szll)
      this.form2.szllList = list

      this.szll={
          "orgId":localStorage.getItem('orgId'),
          "jsxm": "",//教师姓名
          "jssfzh": "",//教师身份证号
          "jssfzz":"",//教师身份证正面照片
          "jssfzf":"",//教师身份证反面照片
          "jsdlht":"",//教师劳动合同
          "jscyzgzs":"",//教师从业资格证书
      }
    }
    ,
    //删除教师
    shanchujiaoshi(e) {
        this.form2.szllList.splice(e, 1)
        localStorage.setItem('form2', JSON.stringify(this.form2))
    }
    ,
    /*增加医疗急救用品*/
    addyljjyp() {
        let list = this.form4.yljjypList

        if (!this.yljjyp.name) {
            ElMessage.error('请输入医疗急救用品名称')
            return false;
        }
        if (!this.yljjyp.img) {
            ElMessage.error('请上传医疗急救用品照片')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.yljjyp)
        this.form4.yljjypList = list

        this.yljjyp={
            "orgId":localStorage.getItem('orgId'),
            "name": "",//医疗急救用品名称
            "img": "",//医疗急救用品图片
        }
    }
    ,
    //删除设备
    delyljjyp(e) {
      //this.form4.yljjypList.splice(this.form4.yljjypList.length-1, 1)
        this.form4.yljjypList.splice(e, 1)
        localStorage.setItem('form4', JSON.stringify(this.form4))
    }
    ,
    /*增加省级教练*/
     addsjjl() {
      let list = this.form5.sjjlList

      if (!this.sjjl.name) {
         ElMessage.error('请输入教练姓名')
         return false;
      }
      if (!this.sjjl.idCardNo) {
         ElMessage.error('请输入教练身份证号')
         return false;
      }
      if (!this.sjjl.idCardZ) {
         ElMessage.error('请上传身份证正面照片')
         return false;
      }
      if (!this.sjjl.idCardF) {
         ElMessage.error('请上传身份证反面照片')
         return false;
      }

      list.token = localStorage.getItem('token')
      list.push(this.sjjl)
      this.form5.sjjlList = list

      this.sjjl={
          "orgId":localStorage.getItem('orgId'),
          "name": "",//教练姓名
          "idCardNo": "",//教练身份证号码
          "idCardZ": "",//教练身份证正面照片
          "idCardF": ""//教练身份证反面照片
      }
    }
    ,
    //删除省级教练
    delsjjl(e) {
      this.form5.sjjlList.splice(e, 1)
      localStorage.setItem('form5', JSON.stringify(this.form5))
    }
    ,
    /*增加3年经验全职教练*/
    addqzjl() {
        let list = this.form5.qzjlList

        if (!this.qzjl.name) {
            ElMessage.error('请输入教练姓名')
            return false;
        }
        if (!this.qzjl.idCardNo) {
            ElMessage.error('请输入教练身份证号')
            return false;
        }
        if (!this.qzjl.idCardZ) {
            ElMessage.error('请上传身份证正面照片')
            return false;
        }
        if (!this.qzjl.idCardF) {
            ElMessage.error('请上传身份证反面照片')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.qzjl)
        this.form5.qzjlList = list

        this.qzjl={
            "orgId":localStorage.getItem('orgId'),
            "name": "",//教练姓名
            "idCardNo": "",//教练身份证号码
            "idCardZ": "",//教练身份证正面照片
            "idCardF": "",//教练身份证反面照片
        }
    }
    ,
    //删除3年经验全职教练
    delqzjl(e) {
        console.log(e)
        this.form5.qzjlList.splice(e, 1)
        localStorage.setItem('form5', JSON.stringify(this.form5))
    }
    ,
    /*增加教研人员*/
    addkcyf() {
        let list = this.form5.kcyfList

        if (!this.kcyf.name) {
            ElMessage.error('请输入教师姓名')
            return false;
        }
        if (!this.kcyf.zw) {
            ElMessage.error('请输入教师职务')
            return false;
        }
        if (!this.kcyf.zs) {
            ElMessage.error('请上传教师研发成果')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.kcyf)
        this.form5.kcyfList = list

        this.kcyf={
            "orgId":localStorage.getItem('orgId'),
            "name": "",//教师姓名
            "zw": "",//教师职务
            "zs": "",//教师研发成果
        }
    }
    ,
    //删除教研人员
    delkcyf(e) {
      console.log(e)
      this.form5.kcyfList.splice(e, 1)
      localStorage.setItem('form5', JSON.stringify(this.form5))
    },

    /*增加急救人员*/
    addjjry() {
        let list = this.form5.jjryList

        if (!this.jjry.name) {
            ElMessage.error('请输入急救人员姓名')
            return false;
        }
        if (!this.jjry.idCardNo) {
            ElMessage.error('请输入急救人员身份证号')
            return false;
        }
        if (!this.jjry.zs) {
            ElMessage.error('请上传急救人员证书')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.jjry)
        this.form5.jjryList = list

        this.jjry={
            "orgId":localStorage.getItem('orgId'),
            "name": "",//急救人员姓名
            "idCardNo":"",//急救人员身份证号
            "zs": "",//急救人员证书
        }
      }
      ,
      //删除急救人员
      deljjry(e) {
          console.log(e)
          this.form5.jjryList.splice(e, 1)
          localStorage.setItem('form5', JSON.stringify(this.form5))
      },

    /*增加安保人员*/
    addabry() {
        let list = this.form5.abryList

        if (!this.abry.name) {
            ElMessage.error('请输入安保人员姓名')
            return false;
        }
        if (!this.abry.idCardNo) {
            ElMessage.error('请输入安保人员身份证号')
            return false;
        }
        if (!this.abry.zs) {
            ElMessage.error('请上传安保人员证书')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.abry)
        this.form5.abryList = list

        this.abry = {
            "orgId":localStorage.getItem('orgId'),
            "name": "",//安保人员姓名
            "idCardNo":"",//安保人员身份证号
            "zs": "",//安保人员证书
        }
    }
    ,
    //删除安保人员
    delabry(e) {
        console.log(e)
        this.form5.abryList.splice(e, 1)
        localStorage.setItem('form5', JSON.stringify(this.form5))
    },
    /*增加业务培训人员*/
    addywpxry() {
        let list = this.form5.ywpxryList

        if (!this.ywpxry.name) {
            ElMessage.error('请输入业务培训人员姓名')
            return false;
        }
        if (!this.ywpxry.idCardNo) {
            ElMessage.error('请输入业务培训人员身份证号')
            return false;
        }
        if (!this.ywpxry.zs) {
            ElMessage.error('请上传业务培训人员证书')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.ywpxry)
        this.form5.ywpxryList = list

        this.ywpxry={
            "orgId":localStorage.getItem('orgId'),
            "name": "",//业务培训人员姓名
            "idCardNo":"",//业务培训人员身份证号
            "zs": "",//业务培训人员证书
        }
    }
    ,
    //删除业务培训人员
    delywpxry(e) {
        console.log(e)
        this.form5.ywpxryList.splice(e, 1)
        localStorage.setItem('form5', JSON.stringify(this.form5))
    },
    /*增加教练人员*/
    addjlry() {
        let list = this.form5.jlryList

        if (!this.jlry.name) {
            ElMessage.error('请输入教练人员姓名')
            return false;
        }
        if (!this.jlry.idCardNo) {
            ElMessage.error('请输入教练人员身份证号')
            return false;
        }
        if (!this.jlry.zs) {
            ElMessage.error('请上传教练人员证书')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.jlry)
        this.form5.jlryList = list

        this.jlry={
            "orgId":localStorage.getItem('orgId'),
            "name": "",//教练人员姓名
            "idCardNo":"",//教练人员身份证号
            "zs": "",//教练人员证书
        }
    }
    ,
    //删除教练人员
    deljlry(e) {
        console.log(e)
        this.form5.jlryList.splice(e, 1)
        localStorage.setItem('form5', JSON.stringify(this.form5))
    },

    /*增加参赛人员*/
    addcsry() {
        let list = this.form6.csryList

        if (!this.csry.name) {
            ElMessage.error('请输入参赛人员姓名')
            return false;
        }
        if (!this.csry.idCardNo) {
            ElMessage.error('请输入参赛人员身份证号')
            return false;
        }
        if (!this.csry.csryTp) {
            ElMessage.error('请上传参赛人员照片')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.csry)
        this.form6.csryList = list

        this.csry={
            "orgId":localStorage.getItem('orgId'),
            "name": "",//参赛人员姓名
            "idCardNo":"",//参赛人员身份证号
            "csryTp": "",//参赛人员证书
        }
    }
    ,
    //删除参赛人员
    delcsry(e) {
        console.log(e)
        this.form6.csryList.splice(e, 1)
        localStorage.setItem('form6', JSON.stringify(this.form6))
    },

    /*增加运动人员*/
    addydyss() {
        let list = this.form6.ydryList

        if (!this.ydry.name) {
            ElMessage.error('请输入运动员姓名')
            return false;
        }
        if (!this.ydry.idCardNo) {
            ElMessage.error('请输入运动员身份证号')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.ydry)
        this.form6.ydryList = list

        this.ydry={
            "orgId":localStorage.getItem('orgId'),
            "name": "",//运动员姓名
            "idCardNo":"",//运动员身份证号
        }
    }
    ,
    //删除运动员
    delydyss(e) {
        console.log(e)
        this.form6.ydryList.splice(e, 1)
        localStorage.setItem('form6', JSON.stringify(this.form6))
    },

    addxcbd() {
        let list = this.form6.xcbdList

        if (!this.xcbd.xcbdTime) {
            ElMessage.error('请输入宣传报道日期')
            return false;
        }
        if (!this.xcbd.xcbdTp) {
            ElMessage.error('请上传宣传报道图片')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.xcbd)
        this.form6.xcbdList = list

        this.xcbd={
            "orgId":localStorage.getItem('orgId'),
            "xcbdTime": "",//宣传报道日期
            "xcbdTp":"",//宣传报道日期
        }
    }
    ,
    //删除宣传报道
    delxcbd(e) {
        console.log(e)
        this.form6.xcbdList.splice(e, 1)
        localStorage.setItem('form6', JSON.stringify(this.form6))
    },

    addgyhd() {
        let list = this.form6.gyhdList

        if (!this.gyhd.gyhdTime) {
            ElMessage.error('请输入公益活动日期')
            return false;
        }
        if (!this.gyhd.gyhdTp) {
            ElMessage.error('请上传公益活动图片')
            return false;
        }

        list.token = localStorage.getItem('token')
        list.push(this.gyhd)
        this.form6.gyhdList = list

        this.gyhd={
            "orgId":localStorage.getItem('orgId'),
            "gyhdTime": "",//公益活动日期
            "gyhdTp":"",//公益活动日期
        }
    }
    ,
    //删除公益活动
    delgyhd(e) {
        console.log(e)
        this.form6.gyhdList.splice(e, 1)
        localStorage.setItem('form6', JSON.stringify(this.form6))
    },


    /** 查询省下拉树结构 */
    getProvinceList(deptId) {
        let queryParams ={
            parentId : deptId
        }
        getDeptList(queryParams).then(response => {
            this.provinceArry = response.data;
        });
    },
    /** 查询市下拉树结构 */
    getCityList(deptId) {
        let queryParams ={
            parentId : deptId
        }
        getDeptList(queryParams).then(response => {
            this.cityArry = response.data;
        });
    },
    /** 查询区下拉树结构 */
    getDistrictList(deptId) {
        let queryParams ={
            parentId : deptId
        }
        getDeptList(queryParams).then(response => {
            this.districtArry = response.data;
        });
    },
    changeDept(data, type){
        //省下拉框改变
        if (type == 0) {
            this.getCityList(data);
        }
        //市下拉框改变
        if (type == 1) {
            this.getDistrictList(data);
            this.form2.deptId = data;
            this.form2.district=''
        }
        //区下拉框改变
        if (type == 2) {
            this.form2.deptId = data;
        }
    },

  }
}
</script>
<style scoped>

#u58 {
  margin-top: 40px;
  background: rgb(242, 242, 242);
  height: 120px;
  padding: 10px 0;
  font-size: 16px;
}

#u51_img {
  width: 1000px;
}

#u52_img {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}

.jindu {
  margin-top: 20px;
  display: flex;
  margin-left: 5px;
}

.jindu .p1 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #CCCCCC;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span1 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #CCCCCC;
}

.jindu .p2 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #FF0000;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span2 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #FF0000;
}


/*.imgx {
  margin-left: -25px;
}*/

.jindu div {
  margin-left: -7px;
}

.hang {
  color: black;
  font-size: 16px;
  /*margin-left: 5%;*/
}

.inputs {
  width: 55%;
  margin-left: 10px;
}

.selects {
  width: 40%;
  margin-left: 10px;
}

.xing {
  color: red;
  font-size: 18px;
  margin-left: 5px;
}

.fontStyle{
    position: absolute;
    margin-left: 95%;
    color: red;
    font-size: 18px;
}

.bei {
  font-size: 16px;
  margin-left: 30px;
  color: #c9c9c9;
}


.el-form-item label {
  color: black;
  font-size: 16px;
}

.buttons {
  cursor: pointer;
  border-width: 0px;
  width: 15%;
  height: 30px;
  background: inherit;
  background-color: rgba(255, 102, 51, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
}

.buttons1 {
  cursor: pointer;
  border-width: 0px;
  width: 40px;
  text-align: center;
  height: 30px;
  background: inherit;
  background-color: #409eff;
  border: none;
  border-radius: 3px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
}

.buttons2 {
  cursor: pointer;
  position: relative;
  left: 37%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
  line-height: 45px;
}

.buttons3 {
  cursor: pointer;
  position: relative;
  left: 20%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 51, 51, 1);
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FF3333;
  text-align: center;
  line-height: 45px;
}
.container{
    display: flex;
    align-items: flex-end;
}
.selectScore {
    width: 20%;
    padding-left: 10%;
}


</style>
<style lang="css">
.el-tooltip__popper {
    white-space: pre-wrap;
}
.el-tooltip__popper .el-tooltip__content {
    white-space: pre-wrap;
}
</style>
